/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

/**
 * Define all the messages existing on the app to translate
 */
export const messages = defineMessages({
	TC_COMPONENTS_UTILS_LRS_REQUIREMENTS_RSVP_EVENT_TEXT: {
		id: 'TC_COMPONENTS_UTILS_LRS_REQUIREMENTS_RSVP_EVENT_TEXT',
		description: 'Display text for RSVP actions in completion requirements descriptions',
		defaultMessage: 'RSVP for',
	},
	TC_COMPONENTS_UTILS_LRS_REQUIREMENTS_FORM_ENTRY_TEXT: {
		id: 'TC_COMPONENTS_UTILS_LRS_REQUIREMENTS_FORM_ENTRY_TEXT',
		description: 'Display text for form objects in completion requirements descriptions',
		defaultMessage: 'entry'
	},
	TC_COMPONENTS_UTILS_LRS_REQUIREMENTS_FORM_ENTRY_CREATE_TEXT: {
		id: 'TC_COMPONENTS_UTILS_LRS_REQUIREMENTS_FORM_ENTRY_CREATE_TEXT',
		description: 'Display text for <created> <form-entry> pairs in completion requirements descriptions',
		defaultMessage: 'submit',
	},
	TC_COMPONENTS_UTILS_LRS_REQUIREMENTS_SUBCONDITION_PARENT_TEXT: {
		id: 'TC_COMPONENTS_UTILS_LRS_REQUIREMENTS_SUBCONDITION_PARENT_TEXT',
		description: 'Display text for parent objects in completion requirements descriptions',
		defaultMessage: 'for {object_title}'
	},
	TC_COMPONENTS_UTILS_RESOURCE_FORMATTED_OPEN_DATE_TEXT: {
		id: 'TC_COMPONENTS_UTILS_RESOURCE_FORMATTED_OPEN_DATE_TEXT',
		description: 'The text to show for a resource to signify when it will be open.',
		defaultMessage: 'This content will open at {time} on {date}.',
	},
	TC_COMPONENTS_UTILS_RESOURCE_FORMATTED_OPEN_DATE_TEXT_ARIA_LABEL: {
		id: 'TC_COMPONENTS_UTILS_RESOURCE_FORMATTED_OPEN_DATE_TEXT_ARIA_LABEL',
		description: 'The aria label text to show for a resource to signify when it will be open.',
		defaultMessage: 'The content for {title} will open at {time} on {date}.',
	},
	TC_COMPONENTS_GENERAL_TEXT_YES: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_YES',
		description: 'Generic "yes" label',
		defaultMessage: 'Yes',
	},
	TC_COMPONENTS_GENERAL_TEXT_NO: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_NO',
		description: 'Generic "no" label',
		defaultMessage: 'No',
	},
	TC_COMPONENTS_GENERAL_TEXT_BACK: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_BACK',
		description: 'Generic "Back" label',
		defaultMessage: 'Back'
	},
	TC_COMPONENTS_GENERAL_TEXT_CLOSED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_CLOSED',
		description: 'Generic "Closed" label',
		defaultMessage: 'Closed'
	},
	TC_COMPONENTS_GENERAL_TEXT_LANGUAGE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LANGUAGE',
		description: 'Generic "Language" label',
		defaultMessage: 'Language'
	},
	TC_COMPONENTS_GENERAL_TEXT_LEARN_MORE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LEARN_MORE',
		description: 'Generic "Learn More" label',
		defaultMessage: 'Learn More'
	},
	TC_COMPONENTS_GENERAL_TEXT_NEXT: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_NEXT',
		description: 'Generic "Next" label',
		defaultMessage: 'Next'
	},
	TC_COMPONENTS_GENERAL_TEXT_SEARCH: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_SEARCH',
		description: 'Generic "Search" label',
		defaultMessage: 'Search'
	},
	TC_COMPONENTS_GENERAL_TEXT_REMOVE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_REMOVE',
		description: 'Generic "Remove" label',
		defaultMessage: 'Remove'
	},
	TC_COMPONENTS_GENERAL_TEXT_COPY: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_COPY',
		description: 'Generic "Copy" label',
		defaultMessage: 'Copy'
	},
	TC_COMPONENTS_GENERAL_TEXT_COPY_SUCCESS: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_COPY_SUCCESS',
		description: 'Alert message when link is automatically copied',
		defaultMessage: 'Copied to clipboard'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_ATTENDED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_ATTENDED',
		description: 'LRS action word for "attended"',
		defaultMessage: 'attended'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_ATTENDING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_ATTENDING',
		description: 'LRS action word for "attending"',
		defaultMessage: 'attending'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_ATTEND: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_ATTEND',
		description: 'LRS action word for "attend"',
		defaultMessage: 'attend'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CLICKED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CLICKED',
		description: 'LRS action word for "clicked"',
		defaultMessage: 'clicked'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CLICKING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CLICKING',
		description: 'LRS action word for "clicking"',
		defaultMessage: 'clicking'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CLICK: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CLICK',
		description: 'LRS action word for "click"',
		defaultMessage: 'click'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_COMPLETED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_COMPLETED',
		description: 'LRS action word for "completed"',
		defaultMessage: 'completed'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_COMPLETING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_COMPLETING',
		description: 'LRS action word for "completing"',
		defaultMessage: 'completing'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_COMPLETE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_COMPLETE',
		description: 'LRS action word for "complete"',
		defaultMessage: 'complete'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CREATED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CREATED',
		description: 'LRS action word for "created"',
		defaultMessage: 'created'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CREATING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CREATING',
		description: 'LRS action word for "creating"',
		defaultMessage: 'creating'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CREATE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CREATE',
		description: 'LRS action word for "create"',
		defaultMessage: 'create'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_DELETED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_DELETED',
		description: 'LRS action word for "deleted"',
		defaultMessage: 'deleted'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_DELETING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_DELETING',
		description: 'LRS action word for "deleting"',
		defaultMessage: 'deleting'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_DELETE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_DELETE',
		description: 'LRS action word for "delete"',
		defaultMessage: 'delete'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_EARN: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_EARN',
		description: 'LRS action word for "earn"',
		defaultMessage: 'earn'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_EARNED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_EARNED',
		description: 'LRS action word for "earned"',
		defaultMessage: 'earned'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_EARNING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_EARNING',
		description: 'LRS action word for "earning"',
		defaultMessage: 'earning'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_FINISHED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_FINISHED',
		description: 'LRS action word for "finished"',
		defaultMessage: 'finished'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_FINISHING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_FINISHING',
		description: 'LRS action word for "finishing"',
		defaultMessage: 'finishing'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_FINISH: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_FINISH',
		description: 'LRS action word for "finish"',
		defaultMessage: 'finish'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_MENTIONED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_MENTIONED',
		description: 'LRS action word for "mentioned"',
		defaultMessage: 'mentioned'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_MENTIONING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_MENTIONING',
		description: 'LRS action word for "mentioning"',
		defaultMessage: 'mentioning'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PASSED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PASSED',
		description: 'LRS action word for "passed"',
		defaultMessage: 'passed'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PASSING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PASSING',
		description: 'LRS action word for "passing"',
		defaultMessage: 'passing'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PASS: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PASS',
		description: 'LRS action word for "pass"',
		defaultMessage: 'pass'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PAUSED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PAUSED',
		description: 'LRS action word for "paused"',
		defaultMessage: 'paused'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PAUSING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PAUSING',
		description: 'LRS action word for "pausing"',
		defaultMessage: 'pausing'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PAUSE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PAUSE',
		description: 'LRS action word for "pause"',
		defaultMessage: 'pause'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PLAYED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PLAYED',
		description: 'LRS action word for "played"',
		defaultMessage: 'played'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PLAYING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PLAYING',
		description: 'LRS action word for "playing"',
		defaultMessage: 'playing'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PLAY: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PLAY',
		description: 'LRS action word for "play"',
		defaultMessage: 'play'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_RSVPED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_RSVPED',
		description: 'LRS action word for "RSVPed"',
		defaultMessage: 'RSVPed'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_RSVPING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_RSVPING',
		description: 'LRS action word for "RSVPing"',
		defaultMessage: 'RSVPing'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_RSVP: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_RSVP',
		description: 'LRS action word for "RSVP"',
		defaultMessage: 'RSVP'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_SELF_COMPLETED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_SELF_COMPLETED',
		description: 'LRS action word for "self completed"',
		defaultMessage: 'marked complete'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_SELF_COMPLETING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_SELF_COMPLETING',
		description: 'LRS action word for "self completing"',
		defaultMessage: 'marking complete'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_SELF_COMPLETE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_SELF_COMPLETE',
		description: 'LRS action word for "self complete"',
		defaultMessage: 'mark complete'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_STARTED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_STARTED',
		description: 'LRS action word for "started"',
		defaultMessage: 'started'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_STARTING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_STARTING',
		description: 'LRS action word for "starting"',
		defaultMessage: 'starting'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_START: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_START',
		description: 'LRS action word for "start"',
		defaultMessage: 'start'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_VIEWED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_VIEWED',
		description: 'LRS action word for "viewed"',
		defaultMessage: 'viewed'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_VIEWING: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_VIEWING',
		description: 'LRS action word for "viewing"',
		defaultMessage: 'viewing'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_VIEW: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_VIEW',
		description: 'LRS action word for "view"',
		defaultMessage: 'view'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_CERTIFICATE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_CERTIFICATE',
		description: 'LRS object type word for "certificate"',
		defaultMessage: 'certificate'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_DISCUSSION_COMMENT: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_DISCUSSION_COMMENT',
		description: 'LRS object type word for "discussion-comment"',
		defaultMessage: 'response'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_DISCUSSION_REPLY: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_DISCUSSION_REPLY',
		description: 'LRS object type word for "discussion-reply"',
		defaultMessage: 'reply'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_DISCUSSION_THREAD: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_DISCUSSION_THREAD',
		description: 'LRS object type word for "discussion-thread"',
		defaultMessage: 'thread'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_DISCUSSION_TOPIC: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_DISCUSSION_TOPIC',
		description: 'LRS object type word for "discussion-topic"',
		defaultMessage: 'topic'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_EMBED: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_EMBED',
		description: 'LRS object type word for "embed"',
		defaultMessage: 'embed'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_EVENT: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_EVENT',
		description: 'LRS object type word for "event"',
		defaultMessage: 'event'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_FORM: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_FORM',
		description: 'LRS object type word for "form"',
		defaultMessage: 'form'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_FORM_ENTRY: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_FORM_ENTRY',
		description: 'LRS object type word for "form-entry"',
		defaultMessage: 'form entry'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_IMAGE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_IMAGE',
		description: 'LRS object type word for "image"',
		defaultMessage: 'image'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_LINK: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_LINK',
		description: 'LRS object type word for "link"',
		defaultMessage: 'link'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_MIRO: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_MIRO',
		description: 'LRS object type word for "Miro" board',
		defaultMessage: 'Miro board'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_MODULE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_MODULE',
		description: 'LRS object type word for "module"',
		defaultMessage: 'module'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_PAGE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_PAGE',
		description: 'LRS object type word for "page"',
		defaultMessage: 'page'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_POINTS: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_POINTS',
		description: 'Plural LRS object type word for "point"',
		defaultMessage: 'points'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_POLL: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_POLL',
		description: 'LRS object type word for "poll" forms',
		defaultMessage: 'poll'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_QUIZ: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_QUIZ',
		description: 'LRS object type word for "quiz" forms',
		defaultMessage: 'quiz'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_SLIDE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_SLIDE',
		description: 'LRS object type word for "slide"',
		defaultMessage: 'slide'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_SESSION: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_SESSION',
		description: 'LRS object type word for "session"',
		defaultMessage: 'session'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_SUBMODULE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_SUBMODULE',
		description: 'LRS object type word for "submodule"',
		defaultMessage: 'submodule'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_SUBMODULE_CONTENT: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_SUBMODULE_CONTENT',
		description: 'LRS object type word for "submodule-content"',
		defaultMessage: 'submodule content'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_VIDEO: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_VIDEO',
		description: 'LRS object type word for "video"',
		defaultMessage: 'video'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_WORDPRESS_GRAVITY_FORM: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_WORDPRESS_GRAVITY_FORM',
		description: 'LRS object type word for "gravity forms" from the DEPRECATED WordPress courses',
		defaultMessage: 'gravity form (WordPress)'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_PARENT_DISPLAY: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_PARENT_DISPLAY',
		description: 'Description for generic LRS parent objects',
		defaultMessage: 'in'
	},
	TC_COMPONENTS_GENERAL_TEXT_LRS_PARENT_MENTIONED_DISPLAY: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_LRS_PARENT_MENTIONED_DISPLAY',
		description: 'Description for an LRS <mentioned> parent object',
		defaultMessage: 'in a'
	},
	TC_COMPONENTS_GENERAL_ADVANCED_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_ADVANCED_LABEL',
		description: 'Generic label for advanced actions',
		defaultMessage: 'Advanced',
	},
	TC_COMPONENTS_GENERAL_CANCEL_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_CANCEL_LABEL',
		description: 'Generic label for "cancel" actions',
		defaultMessage: 'Cancel'
	},
	TC_COMPONENTS_GENERAL_DELETE_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_DELETE_LABEL',
		description: 'Generic label for "delete" actions',
		defaultMessage: 'Delete'
	},
	TC_COMPONENTS_GENERAL_DONE_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_DONE_LABEL',
		description: 'Generic label for "done" actions',
		defaultMessage: 'Done'
	},
	TC_COMPONENTS_GENERAL_EDIT_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_EDIT_LABEL',
		description: 'Generic label for "edit" actions',
		defaultMessage: 'Edit'
	},
	TC_COMPONENTS_GENERAL_DISABLED_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_DISABLED_LABEL',
		description: 'Generic label for "disabled" state',
		defaultMessage: 'Disabled'
	},
	TC_COMPONENTS_GENERAL_INACTIVE_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_INACTIVE_LABEL',
		description: 'Generic label for "inactive" state',
		defaultMessage: 'inactive',
	},
	TC_COMPONENTS_GENERAL_LOADING_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_LOADING_LABEL',
		description: 'Generic label for "loading" state',
		defaultMessage: 'Loading'
	},
	TC_COMPONENTS_GENERAL_MORE_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_MORE_LABEL',
		description: 'Generic label to view more actions',
		defaultMessage: 'More'
	},
	TC_COMPONENTS_GENERAL_BACK_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_BACK_LABEL',
		description: 'Generic label for "back" actions',
		defaultMessage: 'Back'
	},
	TC_COMPONENTS_GENERAL_NEXT_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_NEXT_LABEL',
		description: 'Generic label for "next" actions',
		defaultMessage: 'Next'
	},
	TC_COMPONENTS_GENERAL_SAVE_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_SAVE_LABEL',
		description: 'Generic label for "save" actions',
		defaultMessage: 'Save'
	},
	TC_COMPONENTS_GENERAL_SAVE_LABEL_ACTIVE: {
		id: 'TC_COMPONENTS_GENERAL_SAVE_LABEL_ACTIVE',
		description: 'Saving... This may take awhile',
		defaultMessage: 'Saving... This may take a while.'
	},
	TC_COMPONENTS_GENERAL_SEND_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_SEND_LABEL',
		description: 'Send',
		defaultMessage: 'Send',
	},
	TC_COMPONENTS_GENERAL_SEND_LABEL_ACTIVE: {
		id: 'TC_COMPONENTS_GENERAL_SEND_LABEL_ACTIVE',
		description: 'Sending... This may take awhile.',
		defaultMessage: 'Sending... This may take awhile.',
	},
	TC_COMPONENTS_GENERAL_SUBMIT_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_SUBMIT_LABEL',
		description: 'Generic label for "submit" actions',
		defaultMessage: 'Submit'
	},
	TC_COMPONENTS_GENERAL_TEXT_SUBMITTED_DATE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_SUBMITTED_DATE',
		description: 'Text for submitted date.',
		defaultMessage: 'Submitted {date}'
	},
	TC_COMPONENTS_GENERAL_TEXT_SHOW_MORE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_SHOW_MORE',
		description: 'Message to show more of hidden content',
		defaultMessage: 'Show more',
	},
	TC_COMPONENTS_GENERAL_TEXT_PERCENTAGE_SYMBOL: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_PERCENTAGE_SYMBOL',
		description: 'Message to show a percentage symbol',
		defaultMessage: '%',
	},
	TC_COMPONENTS_GENERAL_TEXT_PERCENTAGE_WITH_VALUE: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_PERCENTAGE_WITH_VALUE',
		description: 'Message to show a percentage value',
		defaultMessage: '{value}%',
	},
	TC_COMPONENTS_GENERAL_TEXT_RANGE_GOES_TO: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_RANGE_GOES_TO',
		description: 'Message to display for "to" in range "from" X "to" Y',
		defaultMessage: 'to'
	},
	TC_COMPONENTS_GENERAL_TEXT_HIDE_ADVANCED_OPTIONS: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_HIDE_ADVANCED_OPTIONS',
		description: 'The text for the "hide advanced options" button',
		defaultMessage: 'Hide advanced options...'
	},
	TC_COMPONENTS_GENERAL_TEXT_SHOW_ADVANCED_OPTIONS: {
		id: 'TC_COMPONENTS_GENERAL_TEXT_SHOW_ADVANCED_OPTIONS',
		description: 'The text for the "show advanced options" button',
		defaultMessage: 'Show advanced options...'
	},
	TC_COMPONENTS_GENERAL_FIELD_OPTION_NONE: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_OPTION_NONE',
		description: 'The field option label for "none" options',
		defaultMessage: '-- None --'
	},
	TC_COMPONENTS_GENERAL_WIDTH_OPTION_FULL: {
		id: 'TC_COMPONENTS_GENERAL_WIDTH_OPTION_FULL',
		description: 'The option label for "full" width',
		defaultMessage: 'Full'
	},
	TC_COMPONENTS_GENERAL_WIDTH_OPTION_THREE_FOURTHS: {
		id: 'TC_COMPONENTS_GENERAL_WIDTH_OPTION_THREE_FOURTHS',
		description: 'The option label for "3/4" width',
		defaultMessage: '3/4'
	},
	TC_COMPONENTS_GENERAL_DROPDOWN_TOGGLE_OPEN: {
		id: 'TC_COMPONENTS_GENERAL_DROPDOWN_TOGGLE_OPEN',
		description: 'The label to open the dropdown',
		defaultMessage: 'Open dropdown'
	},
	TC_COMPONENTS_GENERAL_DROPDOWN_TOGGLE_CLOSE: {
		id: 'TC_COMPONENTS_GENERAL_DROPDOWN_TOGGLE_CLOSE',
		description: 'The label to close the dropdown',
		defaultMessage: 'Close dropdown'
	},
	TC_COMPONENTS_GENERAL_WIDTH_OPTION_TWO_THIRDS: {
		id: 'TC_COMPONENTS_GENERAL_WIDTH_OPTION_TWO_THIRDS',
		description: 'The option label for "2/3" width',
		defaultMessage: '2/3'
	},
	TC_COMPONENTS_GENERAL_WIDTH_OPTION_HALF: {
		id: 'TC_COMPONENTS_GENERAL_WIDTH_OPTION_HALF',
		description: 'The option label for "1/2" width',
		defaultMessage: '1/2'
	},
	TC_COMPONENTS_GENERAL_WIDTH_OPTION_ONE_THIRD: {
		id: 'TC_COMPONENTS_GENERAL_WIDTH_OPTION_ONE_THIRD',
		description: 'The option label for "1/3" width',
		defaultMessage: '1/3'
	},
	TC_COMPONENTS_GENERAL_WIDTH_OPTION_ONE_FOURTH: {
		id: 'TC_COMPONENTS_GENERAL_WIDTH_OPTION_ONE_FOURTH',
		description: 'The option label for "1/4" width',
		defaultMessage: '1/4'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_CHECKBOX: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_CHECKBOX',
		description: 'The user friendly text for the "Checkbox" field type',
		defaultMessage: 'Checkbox'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_CHECKBOXES: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_CHECKBOXES',
		description: 'The user friendly text for the "Checkboxes" field type',
		defaultMessage: 'Checkboxes'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_EMAIL: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_EMAIL',
		description: 'The user friendly text for the "Email" field type',
		defaultMessage: 'Email'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_FILE_UPLOAD: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_FILE_UPLOAD',
		description: 'The user friendly text for the "File Upload" field type',
		defaultMessage: 'File Upload'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_LIKERT_SCALE: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_LIKERT_SCALE',
		description: 'The user friendly text for the "Likert Scale" field type',
		defaultMessage: 'Likert Scale'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_LOCATION: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_LOCATION',
		description: 'The user friendly text for the "Location" field type',
		defaultMessage: 'Location'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_NUMBER: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_NUMBER',
		description: 'The user friendly text for the "Number" field type',
		defaultMessage: 'Number'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_RADIO: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_RADIO',
		description: 'The user friendly text for the "Radio" field type',
		defaultMessage: 'Multiple Choice'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_SECTION: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_SECTION',
		description: 'The user friendly text for the "Section Break" field type',
		defaultMessage: 'Section Heading'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_SELECT: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_SELECT',
		description: 'The user friendly text for the "Select" field type',
		defaultMessage: 'Dropdown'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_SOCIAL_MEDIA: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_SOCIAL_MEDIA',
		description: 'The user friendly text for the "Social Media" field type',
		defaultMessage: 'Social Media'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_SOCIAL_MEDIA_EMAIL: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_SOCIAL_MEDIA_EMAIL',
		description: 'The user friendly text for the "email Social Media" field type',
		defaultMessage: 'Email'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_SOCIAL_MEDIA_FACEBOOK: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_SOCIAL_MEDIA_FACEBOOK',
		description: 'The user friendly text for the "facebook Social Media" field type',
		defaultMessage: 'Facebook'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_SOCIAL_MEDIA_LINKEDIN: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_SOCIAL_MEDIA_LINKEDIN',
		description: 'The user friendly text for the "linkedin Social Media" field type',
		defaultMessage: 'LinkedIn'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_SOCIAL_MEDIA_TWITTER: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_SOCIAL_MEDIA_TWITTER',
		description: 'The user friendly text for the "twitter Social Media" field type',
		defaultMessage: 'Twitter'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_TEXT: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_TEXT',
		description: 'The user friendly text for the "Text" field type',
		defaultMessage: 'Short Answer'
	},
	TC_COMPONENTS_GENERAL_FIELD_TYPE_TEXTAREA: {
		id: 'TC_COMPONENTS_GENERAL_FIELD_TYPE_TEXTAREA',
		description: 'The user friendly text for the "TextArea" field type',
		defaultMessage: 'Paragraph'
	},
	TC_COMPONENTS_ALERT_INFO_PREFIX: {
		id: 'TC_COMPONENTS_ALERT_INFO_PREFIX',
		description: 'Prefix the info alert message, ex: Heads up! Something is happening',
		defaultMessage: 'Heads up!'
	},
	TC_COMPONENTS_ALERT_ERROR_PREFIX: {
		id: 'TC_COMPONENTS_ALERT_ERROR_PREFIX',
		description: 'Prefix the alert error message, ex: Oops! Error message',
		defaultMessage: 'Oops!'
	},
	TC_COMPONENTS_ALERT_SUCCESS_PREFIX: {
		id: 'TC_COMPONENTS_ALERT_SUCCESS_PREFIX',
		description: 'Prefix the alert success message, ex: Great! Success message',
		defaultMessage: 'Great!'
	},
	TC_COMPONENTS_ALERT_WARNING_PREFIX: {
		id: 'TC_COMPONENTS_ALERT_WARNING_PREFIX',
		description: 'Prefix the alert warning message, ex: Warning: Error message',
		defaultMessage: 'Warning:'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_BUTTON_TEXT_ADD_NEW_SIGNATURE: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_BUTTON_TEXT_ADD_NEW_SIGNATURE',
		description: 'Label text for button that adds a new signature to the certificate template',
		defaultMessage: 'Add signature'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_BACKGROUND_IMAGE: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_BACKGROUND_IMAGE',
		description: 'The field label text for the "background_image" field in the certificate editor',
		defaultMessage: 'Background Image'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_BADGE: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_BADGE',
		description: 'The field label text for the "badge" field in the certificate editor',
		defaultMessage: 'Badge'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_BODY: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_BODY',
		description: 'The field label text for the "body" field in the certificate editor',
		defaultMessage: 'Body'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_LOGO: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_LOGO',
		description: 'The field label text for the "logo" field in the certificate editor',
		defaultMessage: 'Logo'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_QR_CODE: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_QR_CODE',
		description: 'The field label text for the "qr_code" field in the certificate editor',
		defaultMessage: 'QR Code'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_SIGNATURES: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_FIELD_LABEL_SIGNATURES',
		description: 'The field label text for the "signatures" field in the certificate editor',
		defaultMessage: 'Signatures'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_HEADER_ADDITIONAL_SETTINGS: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_HEADER_ADDITIONAL_SETTINGS',
		description: 'The header text for the group of additional settings in the certificate editor',
		defaultMessage: 'Additional Settings'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_PERSON_SELECT_NEW_PROMPT: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_PERSON_SELECT_NEW_PROMPT',
		description: 'The option text to prompt a user to create a new signature',
		defaultMessage: 'Create new signature'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_PERSON_FIELD_LABEL_AFFILIATION: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_PERSON_FIELD_LABEL_AFFILIATION',
		description: 'The field label text for the "affiliation" field for a person in the certificate editor',
		defaultMessage: 'Affiliation'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_PERSON_FIELD_LABEL_NAME: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_PERSON_FIELD_LABEL_NAME',
		description: 'The field label text for the "name" field for a person in the certificate editor',
		defaultMessage: 'Name'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_PERSON_FIELD_LABEL_SIGNATURE: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_PERSON_FIELD_LABEL_SIGNATURE',
		description: 'The field label text for the "signature" field for a person in the certificate editor',
		defaultMessage: 'Signature'
	},
	TC_COMPONENTS_CERTIFICATE_EDITOR_SELECT_PLACEHOLDER_PERSON: {
		id: 'TC_COMPONENTS_CERTIFICATE_EDITOR_SELECT_PLACEHOLDER_PERSON',
		description: 'Placeholder text for signature options select input',
		defaultMessage: 'Select a signature...'
	},
	TC_COMPONENTS_DATETIME_PICKER_LABEL_TEXT_DATE: {
		id: 'TC_COMPONENTS_DATETIME_PICKER_LABEL_TEXT_DATE',
		description: 'Label text for the "Date" field in the Datetime picker form field.',
		defaultMessage: 'Date',
	},
	TC_COMPONENTS_DATETIME_PICKER_LABEL_TEXT_TIME: {
		id: 'TC_COMPONENTS_DATETIME_PICKER_LABEL_TEXT_TIME',
		description: 'Label text for the "Time" field in the Datetime picker form field.',
		defaultMessage: 'Time',
	},
	TC_COMPONENTS_DATETIME_PICKER_LABEL_TEXT_TIMEZONE: {
		id: 'TC_COMPONENTS_DATETIME_PICKER_LABEL_TEXT_TIMEZONE',
		description: 'Label text for the "Timezone" field in the Datetime picker form field.',
		defaultMessage: 'Timezone',
	},
	TC_COMPONENTS_DATETIME_RANGE_PICKER_LABEL_TEXT_START_DATE: {
		id: 'TC_COMPONENTS_DATETIME_RANGE_PICKER_LABEL_TEXT_START_DATE',
		description: 'Label text for the "Start Date" field in the Datetime picker form field for a range of two values.',
		defaultMessage: 'Start Date',
	},
	TC_COMPONENTS_DATETIME_RANGE_PICKER_LABEL_TEXT_START_TIME: {
		id: 'TC_COMPONENTS_DATETIME_RANGE_PICKER_LABEL_TEXT_START_TIME',
		description: 'Label text for the "Start Time" field in the Datetime picker form field for a range of two values.',
		defaultMessage: 'Start Time',
	},
	TC_COMPONENTS_DATETIME_RANGE_PICKER_LABEL_TEXT_END_DATE: {
		id: 'TC_COMPONENTS_DATETIME_RANGE_PICKER_LABEL_TEXT_END_DATE',
		description: 'Label text for the "End Date" field in the Datetime picker form field for a range of two values.',
		defaultMessage: 'End Date',
	},
	TC_COMPONENTS_DATETIME_RANGE_PICKER_LABEL_TEXT_END_TIME: {
		id: 'TC_COMPONENTS_DATETIME_RANGE_PICKER_LABEL_TEXT_END_TIME',
		description: 'Label text for the "End Time" field in the Datetime picker form field for a range of two values.',
		defaultMessage: 'End Time',
	},
	TC_COMPONENTS_DELETE_CONFIRMATION_MODEL_SUBMIT_BUTTON_TEXT_LONG: {
		id: 'TC_COMPONENTS_DELETE_CONFIRMATION_MODEL_SUBMIT_BUTTON_TEXT_LONG',
		description: 'The label text for submit button for delete confirmation models.',
		defaultMessage: 'I understand the consequences, delete this {type}'
	},
	TC_COMPONENTS_DELETE_CONFIRMATION_MODEL_SUBMIT_BUTTON_TEXT_SHORT: {
		id: 'TC_COMPONENTS_DELETE_CONFIRMATION_MODEL_SUBMIT_BUTTON_TEXT_SHORT',
		description: 'The label text for submit button for delete confirmation models.',
		defaultMessage: 'Delete this {type}'
	},
	TC_COMPONENTS_DELETE_CONFIRMATION_MODEL_HEADER_TEXT: {
		id: 'TC_COMPONENTS_DELETE_CONFIRMATION_MODEL_HEADER_TEXT',
		description: 'The header text for the delete confirmation modal',
		defaultMessage: 'Delete {title}'
	},
	TC_COMPONENTS_DELETE_CONFIRMATION_MODEL_INFO_TEXT: {
		id: 'TC_COMPONENTS_DELETE_CONFIRMATION_MODEL_INFO_TEXT',
		description: 'The info alert text for the delete confirmation modal',
		defaultMessage: 'This action cannot be undone.'
	},
	TC_COMPONENTS_DELETE_CONFIRMATION_MODEL_FIELD_LABEL_TEXT_CONFIRMATION: {
		id: 'TC_COMPONENTS_DELETE_CONFIRMATION_MODEL_FIELD_LABEL_TEXT_CONFIRMATION',
		description: 'The field label for confirmation checkboxes',
		defaultMessage: 'Yes, I am certain'
	},
	TC_COMPONENTS_DELETE_CONFIRMATION_MODAL_ERROR_MSG_TITLE: {
		id: 'TC_COMPONENTS_DELETE_CONFIRMATION_MODAL_ERROR_MSG_TITLE',
		description: 'Error message text for deleting a resource with a title',
		defaultMessage: 'There was an issue deleting {title}, please try again later.'
	},
	TC_COMPONENTS_DELETE_CONFIRMATION_MODAL_ERROR_MSG_TYPE: {
		id: 'TC_COMPONENTS_DELETE_CONFIRMATION_MODAL_ERROR_MSG_TYPE',
		description: 'Error message text for deleting a generic data type',
		defaultMessage: 'There was an issue deleting the {type}, please try again later.'
	},
	TC_COMPONENTS_GENERAL_PREVIEW_LABEL: {
		id: 'TC_COMPONENTS_GENERAL_PREVIEW_LABEL',
		description: 'The alt text for image previews.',
		defaultMessage: 'Preview'
	},
	TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_PREVIEW: {
		id: 'TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_PREVIEW',
		description: 'The hover text for the link to a preview of the file.',
		defaultMessage: 'File preview'
	},
	TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_SIZE: {
		id: 'TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_SIZE',
		description: 'The hover text for the size of file.',
		defaultMessage: 'File size'
	},
	TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_REMOVE: {
		id: 'TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_REMOVE',
		description: 'The hover text for the "remove file" button for a file',
		defaultMessage: 'Remove file'
	},
	TC_COMPONENTS_EMBEDDED_FORM_MSG_TEXT_LOAD_ERROR: {
		id: 'TC_COMPONENTS_EMBEDDED_FORM_MSG_TEXT_LOAD_ERROR',
		description: 'Error message text for loading a form',
		defaultMessage: 'There was an error loading the form. Please contact support@techchange.org.'
	},
	TC_COMPONENTS_FORM_EMPTY_SECTION_SUBMIT_PROMPT: {
		id: 'TC_COMPONENTS_FORM_EMPTY_SECTION_SUBMIT_PROMPT',
		description: 'Helper text to prompt user to submit form',
		defaultMessage: 'Click submit to finish'
	},
	TC_COMPONENTS_FORM_DESCRIPTION_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_FORM: {
		id: 'TC_COMPONENTS_FORM_DESCRIPTION_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_FORM',
		description: 'The field placeholder text for a "form description" field.',
		defaultMessage: 'Form description'
	},
	TC_COMPONENTS_FORM_DESCRIPTION_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_POLL: {
		id: 'TC_COMPONENTS_FORM_DESCRIPTION_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_POLL',
		description: 'The field placeholder text for a "poll description" field.',
		defaultMessage: 'Poll description'
	},
	TC_COMPONENTS_FORM_DESCRIPTION_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_QUIZ: {
		id: 'TC_COMPONENTS_FORM_DESCRIPTION_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_QUIZ',
		description: 'The field placeholder text for a "quiz description" field.',
		defaultMessage: 'Quiz description'
	},
	TC_COMPONENTS_FORM_EDITOR_DEFAULT_FORM_TITLE: {
		id: 'TC_COMPONENTS_FORM_EDITOR_DEFAULT_FORM_TITLE',
		description: 'Default value for a form title.',
		defaultMessage: 'Untitled form'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_FORM_LANGUAGE: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_FORM_LANGUAGE',
		description: 'The field label text to show when editing the "language" for a form',
		defaultMessage: 'Language',
	},
	TC_COMPONENTS_FORM_EDITOR_HELPER_TEXT_ADD_TRANSLATION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_HELPER_TEXT_ADD_TRANSLATION',
		description: 'The helper text for adding a new form translation',
		defaultMessage: 'There is no {language} translation for this form.\nWould you like to add one?',
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_LABEL_TEXT_TRANSLATION_ADD: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_LABEL_TEXT_TRANSLATION_ADD',
		description: 'The button label for adding a new form translation',
		defaultMessage: 'Add Translation',
	},
	TC_COMPONENTS_FORM_EDITOR_NAVIGATION_OPTIONS_SECTION_PROMPT: {
		id: 'TC_COMPONENTS_FORM_EDITOR_NAVIGATION_OPTIONS_SECTIONS_PROMPT',
		description: 'Text description providing context for navigation option selection.',
		defaultMessage: 'After section {number}'
	},
	TC_COMPONENTS_FORM_EDITOR_NAVIGATION_OPTIONS_DEFAULT: {
		id: 'TC_COMPONENTS_FORM_EDITOR_NAVIGATION_OPTIONS_DEFAULT',
		description: 'Option label for default type form section navigation',
		defaultMessage: 'Continue to next section'
	},
	TC_COMPONENTS_FORM_EDITOR_NAVIGATION_OPTIONS_SECTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_NAVIGATION_OPTIONS_SECTION',
		description: 'Option label for section type form section navigation',
		defaultMessage: 'Go to Section {number} ({title})'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD',
		description: 'The button text for adding a form item in the form editor',
		defaultMessage: 'Add...'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_PREVIEW: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_PREVIEW',
		description: 'The button text for previewing a form in the form editor',
		defaultMessage: 'Preview the form in {language}.'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_LABEL_PREVIEW_TICKET_TYPE: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_LABEL_PREVIEW_TICKET_TYPE',
		description: 'The dropdown label for selecting a ticket type when previewing a form in the editor',
		defaultMessage: 'Ticket Type:'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_LABEL_PREVIEW_TICKET_GROUP: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_PREVIEW_TICKET_GROUP',
		description: 'The dropdown label for selecting a ticket group when previewing a form in the editor',
		defaultMessage: 'Ticket Group:'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_SECTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_SECTION',
		description: 'The button text for the "add section" button in the form editor',
		defaultMessage: 'Add section'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_APPLICATION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_APPLICATION',
		description: 'The button text for the "add new question" button dropdown in the form editor for an application form',
		defaultMessage: 'Add question to application'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_FORM: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_FORM',
		description: 'The button text for the "add new question" button dropdown in the form editor for a normal form',
		defaultMessage: 'Add question to form'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_POLL: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_POLL',
		description: 'The button text for the "add new question" button dropdown in the form editor for a poll form',
		defaultMessage: 'Add question to poll'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_POST_REGISTRATION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_POST_REGISTRATION',
		description: 'The button text for the "add new question" button dropdown in the form editor for a post-registration form',
		defaultMessage: 'Add question to post-registration form'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_PROFILE: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_PROFILE',
		description: 'The button text for the "add new question" button dropdown in the form editor for a profile form',
		defaultMessage: 'Add question to profile'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_SECTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_SECTION',
		description: 'The button text for the "add new question" button dropdown in the form editor for a form section',
		defaultMessage: 'Add question to section'
	},
	TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_QUIZ: {
		id: 'TC_COMPONENTS_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION_TO_QUIZ',
		description: 'The button text for the "add new question" button dropdown in the form editor for a quiz form',
		defaultMessage: 'Add question to quiz'
	},
	TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_CLONE_QUESTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_CLONE_QUESTION',
		description: 'The hover text for the "create a copy of the question" button in the form editor',
		defaultMessage: 'Create a copy of the question'
	},
	TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_MOVE_QUESTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_MOVE_QUESTION',
		description: 'The hover text for the "move question" drag-and-drop button in the form editor',
		defaultMessage: 'Move the question'
	},
	TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_REMOVE_QUESTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_REMOVE_QUESTION',
		description: 'The hover text for the "remove question" button in the form editor',
		defaultMessage: 'Remove the question'
	},
	TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_REQUIRED_QUESTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_REQUIRED_QUESTION',
		description: 'The hover text for the "required question" switch in the form editor',
		defaultMessage: 'Make the question required'
	},
	TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_SHOW_AS_FILTER_QUESTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_SHOW_AS_FILTER_QUESTION',
		description: 'The hover text for the "show as filter" switch in the form editor',
		defaultMessage: 'Show this field as a filter option in the participant directory'
	},
	TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_ADD_OPTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_ADD_OPTION',
		description: 'The hover text for the "add option" button for form fields in the form editor',
		defaultMessage: 'Add option'
	},
	TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_MOVE_OPTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_MOVE_OPTION',
		description: 'The hover text for the "move option" drag-and-drop button for form fields in the form editor',
		defaultMessage: 'Move option'
	},
	TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_REMOVE_OPTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_REMOVE_OPTION',
		description: 'The hover text for the "remove option" button for form fields in the form editor',
		defaultMessage: 'Remove option'
	},
	TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_MOVE_SECTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_MOVE_SECTION',
		description: 'The hover text for the "move section" drag-and-drop button in the form editor',
		defaultMessage: 'Move the section'
	},
	TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_REMOVE_SECTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_HOVER_TEXT_REMOVE_SECTION',
		description: 'The hover text for the "remove question" button in the form editor',
		defaultMessage: 'Remove the section'
	},
	TC_COMPONENTS_FORM_EDITOR_ARIA_LABEL_REMOVE_SECTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_ARIA_LABEL_REMOVE_SECTION',
		description: 'The aria label for the "remove question" button in the form editor',
		defaultMessage: 'Remove section {section_number}'
	},
	TC_COMPONENTS_FORM_EDITOR_LABEL_TEXT_FORM_DESCRIPTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_LABEL_TEXT_FORM_DESCRIPTION',
		description: 'The field label for "form description" input in the form editor',
		defaultMessage: 'Form Description'
	},
	TC_COMPONENTS_FORM_EDITOR_LABEL_TEXT_FORM_TITLE: {
		id: 'TC_COMPONENTS_FORM_EDITOR_LABEL_TEXT_FORM_TITLE',
		description: 'The field label for "form title" input in the form editor',
		defaultMessage: 'Form Title'
	},
	TC_COMPONENTS_FORM_EDITOR_LABEL_TEXT_FORM_WIDTH: {
		id: 'TC_COMPONENTS_FORM_EDITOR_LABEL_TEXT_FORM_WIDTH',
		description: 'The field label for "form width" input in the form editor',
		defaultMessage: 'Width'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_SETTINGS_DROPDOWN_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_SETTINGS_DROPDOWN_BUTTON_TITLE',
		description: 'Button title to view more form field settings',
		defaultMessage: 'More options'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_SETTINGS_DROPDOWN_BUTTON_ARIA_LABEL: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_SETTINGS_DROPDOWN_BUTTON_ARIA_LABEL',
		description: 'Button aria label to view more form field settings',
		defaultMessage: 'More options for {field_title}'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_SETTINGS_CONDITIONAL_CHECKBOX_LABEL: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_SETTINGS_CONDITIONAL_CHECKBOX_LABEL',
		description: 'Checkbox input label for toggling a form field to be conditional.',
		defaultMessage: 'Go to section based on answer'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_HELP: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_HELP',
		description: 'The field placeholder text for the "help" field for a form field in the form editor',
		defaultMessage: 'Description'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_PLACEHOLDER: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_PLACEHOLDER',
		description: 'The field placeholder text for the "placeholder" field for a form field in the form editor',
		defaultMessage: 'Placeholder text'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_AND_HOVER_TEXT_CHOOSE_ANSWERS_AND_FEEDBACK: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_AND_HOVER_TEXT_CHOOSE_ANSWERS_AND_FEEDBACK',
		description: 'The icon/hover text for choosing the answers and feedback for a field in the form editor',
		defaultMessage: 'Choose answers & feedback'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_ARIA_LABEL_TEXT_CHOOSE_ANSWERS_AND_FEEDBACK: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_ARIA_LABEL_TEXT_CHOOSE_ANSWERS_AND_FEEDBACK',
		description: 'The aria-label text for choosing the answers and feedback for a field in the form editor',
		defaultMessage: 'Choose answers & feedback for {field_title}'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_FORM_FIELD_REQUIRED: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_FORM_FIELD_REQUIRED',
		description: 'The field label text for the "required" field for a form field in the form editor',
		defaultMessage: 'Required'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_FORM_FIELD_SHOW_AS_FILTER: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_FORM_FIELD_SHOW_AS_FILTER',
		description: 'The field label text for the "filter" field for a form field in the form editor',
		defaultMessage: 'Show as filter'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_FORM_FIELD_TITLE: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_FORM_FIELD_TITLE',
		description: 'The field label text for the "title" field for a form field in the form editor',
		defaultMessage: 'Question #{index}'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_OPTION_LIKERT_SCALE: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_OPTION_LIKERT_SCALE',
		description: 'The field placeholder text value for the "form_field_option" field for a likert scale form field in the form editor',
		defaultMessage: 'Label (optional)'
	},
	TC_COMPONENTS_FORM_EDITOR_LIKERT_SCALE_CHOOSE_MIN_VALUE_LABEL: {
		id: 'TC_COMPONENTS_FORM_EDITOR_LIKERT_SCALE_CHOOSE_MIN_VALUE_LABEL',
		description: 'The input label text for the "choose minimum value" for a likert scale question in the form editor',
		defaultMessage: 'Choose minimum value',
	},
	TC_COMPONENTS_FORM_EDITOR_LIKERT_SCALE_CHOOSE_MAX_VALUE_LABEL: {
		id: 'TC_COMPONENTS_FORM_EDITOR_LIKERT_SCALE_CHOOSE_MAX_VALUE_LABEL',
		description: 'The input label text for the "choose maximum value" for a likert scale question in the form editor',
		defaultMessage: 'Choose maximum value',
	},
	TC_COMPONENTS_FORM_EDITOR_SOCIAL_MEDIA_FIELD_CHOOSE_SUBTYPE_LABEL: {
		id: 'TC_COMPONENTS_FORM_EDITOR_SOCIAL_MEDIA_FIELD_CHOOSE_SUBTYPE_LABEL',
		description: 'The input label text for the "choose subtype" for a social media question in the form editor',
		defaultMessage: 'Choose the social media type',
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_DESCRIPTION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_DESCRIPTION',
		description: 'The field placeholder text for the "description" field for a form section in the form editor',
		defaultMessage: 'Section description'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_LEGEND: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_LEGEND',
		description: 'The field placeholder text for the "legend" field for a form section in the form editor',
		defaultMessage: 'Section title'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_ADVANCED_SETTINGS_TITLE: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_ADVANCED_SETTINGS_TITLE',
		description: 'The field placeholder text for the form section advanced settings title',
		defaultMessage: 'Advanced Navigation Settings'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_ADVANCED_SETTINGS_TICKETS: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_ADVANCED_SETTINGS_TICKETS',
		description: 'The field placeholder text for the form section advanced settings type for tickets',
		defaultMessage: 'Continue to next section based on ticket'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_ADVANCED_SETTINGS_TICKETS_EMPTY: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_ADVANCED_SETTINGS_TICKETS_EMPTY',
		description: 'Message to display when there are no ticket types for which to configure form navigation settings',
		defaultMessage: 'There are no tickets for this product'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_ADVANCED_SETTINGS_TICKET_GROUPS: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_ADVANCED_SETTINGS_TICKET_GROUPS',
		description: 'The field placeholder text for the form section advanced settings type for ticket groups',
		defaultMessage: 'Continue to next section based on ticket group'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_ADVANCED_SETTINGS_TICKET_GROUPS_EMPTY: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_ADVANCED_SETTINGS_TICKET_GROUPS_EMPTY',
		description: 'Message to display when there are no ticket groups for which to configure form navigation settings',
		defaultMessage: 'There are no ticket groups for this product'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_CHOOSE_ANSWER_AND_FEEDBACK_MODAL_ANSWER_HEADER: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_CHOOSE_ANSWER_AND_FEEDBACK_MODAL_ANSWER_HEADER',
		description: 'The header text for the modal to "choose correct answers" for a field in the form editor',
		defaultMessage: 'Choose correct answers'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_CHOOSE_ANSWER_AND_FEEDBACK_MODAL_FEEDBACK_HEADER: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_CHOOSE_ANSWER_AND_FEEDBACK_MODAL_FEEDBACK_HEADER',
		description: 'The header text for the modal to "choose answer feedback" for a field in the form editor',
		defaultMessage: 'Choose answer feedback'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_SUBMISSION_FEEDBACK_CORRECT: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_SUBMISSION_FEEDBACK_CORRECT',
		description: 'The field label text for the "submission feedback correct" for a field in the form editor',
		defaultMessage: 'Feedback for correct answer'
	},
	TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_SUBMISSION_FEEDBACK_INCORRECT: {
		id: 'TC_COMPONENTS_FORM_EDITOR_FIELD_LABEL_TEXT_SUBMISSION_FEEDBACK_INCORRECT',
		description: 'The field label text for the "submission feedback incorrect" for a field in the form editor',
		defaultMessage: 'Feedback for incorrect answer'
	},
	TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_EMAIL: {
		id: 'TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_EMAIL',
		description: 'The input placeholder text for the preview "email" input form fields in the form editor',
		defaultMessage: 'Email - Placeholder Text'
	},
	TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_CHECKBOX: {
		id: 'TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_CHECKBOX',
		description: 'The input placeholder text for the preview "checkbox" input form fields in the form editor',
		defaultMessage: 'Checkbox - Placeholder Text'
	},
	TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_SELECT: {
		id: 'TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_SELECT',
		description: 'The input placeholder text for the preview "select" input form fields in the form editor',
		defaultMessage: 'Dropdown - Placeholder Text'
	},
	TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_FILE_UPLOAD: {
		id: 'TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_FILE_UPLOAD',
		description: 'The input placeholder text for the preview "file upload" input form fields in the form editor',
		defaultMessage: 'Choose File'
	},
	TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_LOCATION: {
		id: 'TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_LOCATION',
		description: 'The input placeholder text for the preview "location" input form fields in the form editor',
		defaultMessage: 'Location - Placeholder Text'
	},
	TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_PERCENTAGE: {
		id: 'TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_PERCENTAGE',
		description: 'The input placeholder text for the preview "percentage" input form fields in the form editor',
		defaultMessage: 'Percentage'
	},
	TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_SOCIAL_MEDIA: {
		id: 'TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_SOCIAL_MEDIA',
		description: 'The input placeholder text for the preview "social media" input form fields in the form editor',
		defaultMessage: 'Social Media'
	},
	TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_TEXT: {
		id: 'TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_TEXT',
		description: 'The input placeholder text for the preview "text" input form fields in the form editor',
		defaultMessage: 'Short Answer - Placeholder Text'
	},
	TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_TEXTAREA: {
		id: 'TC_COMPONENTS_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_TEXTAREA',
		description: 'The input placeholder text for the preview "textarea" input form fields in the form editor',
		defaultMessage: 'Long Answer - Placeholder Text'
	},
	TC_COMPONENTS_FORM_EDITOR_MSG_TEXT_FIELD_OPTION_NAME: {
		id: 'TC_COMPONENTS_FORM_EDITOR_MSG_TEXT_FIELD_OPTION_NAME',
		description: 'The field option label for a named option in the form editor',
		defaultMessage: 'Option {name}'
	},
	TC_COMPONENTS_FORM_EDITOR_MSG_TEXT_SAVE_ERROR: {
		id: 'TC_COMPONENTS_FORM_EDITOR_MSG_TEXT_SAVE_ERROR',
		description: 'Error message text for saving the form editor',
		defaultMessage: 'Error while saving the form, please try again later.'
	},
	TC_COMPONENTS_FORM_EDITOR_SECTION_DEFAULT_TITLE: {
		id: 'TC_COMPONENTS_FORM_EDITOR_DEFAULT_TITLE',
		description: 'Default title for a form section',
		defaultMessage: 'Untitled Section {sectionNumber}',
	},
	TC_COMPONENTS_FORM_EDITOR_SECTION_HEADER: {
		id: 'TC_COMPONENTS_FORM_EDITOR_SECTION_HEADER',
		description: 'Text to display for form section headers',
		defaultMessage: 'Section {sectionNumber} of {numSections}',
	},
	TC_COMPONENTS_FORM_ERROR_DEFAULT: {
		id: 'TC_COMPONENTS_FORM_ERROR_DEFAULT',
		description: 'Generic error for field default form validation',
		defaultMessage: 'This field is invalid.'
	},
	TC_COMPONENTS_FORM_ERROR_REQUIRED: {
		id: 'TC_COMPONENTS_FORM_ERROR_REQUIRED',
		description: 'Generic error for field required form validation',
		defaultMessage: 'This field is required.'
	},
	TC_COMPONENTS_FORM_ERROR_MATCHES: {
		id: 'TC_COMPONENTS_FORM_ERROR_MATCHES',
		description: 'Generic error for matches field form validation',
		defaultMessage: 'This does not match {fieldName}.'
	},
	TC_COMPONENTS_FORM_ERROR_LENGTH: {
		id: 'TC_COMPONENTS_FORM_ERROR_LENGTH',
		description: 'Generic error for input length validation',
		defaultMessage: 'This must be between {min} and {max} characters in length.'
	},
	TC_COMPONENTS_FORM_ERROR_NUMBER: {
		id: 'TC_COMPONENTS_FORM_ERROR_NUMBER',
		description: 'Generic error for field number form validation',
		defaultMessage: 'The number is invalid.'
	},
	TC_COMPONENTS_FORM_ERROR_EMAIL: {
		id: 'TC_COMPONENTS_FORM_ERROR_EMAIL',
		description: 'Generic error for field email form validation',
		defaultMessage: 'The email address is invalid.'
	},
	TC_COMPONENTS_FORM_ERROR_SLUG: {
		id: 'TC_COMPONENTS_FORM_ERROR_SLUG',
		description: 'Generic error for field slug form validation',
		defaultMessage: 'This slug is invalid. Slugs can only contain letters, numbers, underscores, or hyphens.'
	},
	TC_COMPONENTS_FORM_ERROR_URL: {
		id: 'TC_COMPONENTS_FORM_ERROR_URL',
		description: 'Generic error for field url form validation',
		defaultMessage: 'This url is invalid.'
	},
	TC_COMPONENTS_FORM_ERROR_CREDITCARD_NUMBER: {
		id: 'TC_COMPONENTS_FORM_ERROR_CREDITCARD_NUMBER',
		description: 'Generic error for creditcard number form validation',
		defaultMessage: 'The card number is invalid.'
	},
	TC_COMPONENTS_FORM_ERROR_CREDITCARD_CVC: {
		id: 'TC_COMPONENTS_FORM_ERROR_CREDITCARD_CVC',
		description: 'Generic error for creditcard cvc form validation',
		defaultMessage: 'The security code is invalid.'
	},
	TC_COMPONENTS_FORM_ERROR_CREDITCARD_EXPIRY: {
		id: 'TC_COMPONENTS_FORM_ERROR_CREDITCARD_EXPIRY',
		description: 'Generic error for creditcard expiry date form validation',
		defaultMessage: 'The expiry date is invalid.'
	},
	TC_COMPONENTS_FORM_INPUT_TEXT_EMPTY_VALUE: {
		id: 'TC_COMPONENTS_FORM_INPUT_TEXT_EMPTY_VALUE',
		description: 'Message to show for an empty value of a form input in display mode',
		defaultMessage: 'N/A',
	},
	TC_COMPONENTS_FORM_INPUT_CHECKBOX_DISPLAY_TEXT_TRUE: {
		id: 'TC_COMPONENTS_FORM_INPUT_CHECKBOX_DISPLAY_TEXT_TRUE',
		description: 'The display text for checkbox inputs with value of "true"',
		defaultMessage: 'Yes',
	},
	TC_COMPONENTS_FORM_INPUT_CHECKBOX_DISPLAY_TEXT_FALSE: {
		id: 'TC_COMPONENTS_FORM_INPUT_CHECKBOX_DISPLAY_TEXT_FALSE',
		description: 'The display text for checkbox inputs with value of "false"',
		defaultMessage: 'No',
	},
	TC_COMPONENTS_FORM_INPUT_FILE_UPLOAD_BUTTON_TEXT: {
		id: 'TC_COMPONENTS_FORM_INPUT_FILE_UPLOAD_BUTTON_TEXT',
		description: 'The button text for the "file upload" button in a file input',
		defaultMessage: 'Choose File'
	},
	TC_COMPONENTS_PASSWORD_INPUT_BUTTON_SHOW_PASSWORD_TEXT: {
		id: 'TC_COMPONENTS_PASSWORD_INPUT_BUTTON_SHOW_PASSWORD_TEXT',
		description: 'The label text for the button used to toggle password visibility (on).',
		defaultMessage: 'Show password'
	},
	TC_COMPONENTS_PASSWORD_INPUT_BUTTON_HIDE_PASSWORD_TEXT: {
		id: 'TC_COMPONENTS_PASSWORD_INPUT_BUTTON_HIDE_PASSWORD_TEXT',
		description: 'The label text for the button used to toggle password visibility (off).',
		defaultMessage: 'Hide password'
	},
	TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_ONLY_ME_LABEL_TEXT: {
		id: 'TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_ONLY_ME_LABEL_TEXT',
		description: 'Label text for the DEPRECATED "only me" privacy dropdown option',
		defaultMessage: 'Only me',
	},
	TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_ONLY_ME_HELP_TEXT: {
		id: 'TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_ONLY_ME_HELP_TEXT',
		description: 'Help text for the DEPRECATED "only me" privacy dropdown option',
		defaultMessage: 'Only visible to me.',
	},
	TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_FACILITATORS_LABEL_TEXT: {
		id: 'TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_FACILITATORS_LABEL_TEXT',
		description: 'Label text for the "facilitators" privacy dropdown option',
		defaultMessage: 'Facilitators',
	},
	TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_FACILITATORS_HELP_TEXT: {
		id: 'TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_FACILITATORS_HELP_TEXT',
		description: 'Help text for the "facilitators" privacy dropdown option',
		defaultMessage: 'Only visible to my course administrators and facilitators.',
	},
	TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_CLASSMATES_LABEL_TEXT: {
		id: 'TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_CLASSMATES_LABEL_TEXT',
		description: 'Label text for the "classmates" privacy dropdown option',
		defaultMessage: 'Classmates',
	},
	TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_CLASSMATES_HELP_TEXT: {
		id: 'TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_CLASSMATES_HELP_TEXT',
		description: 'Help text for the "classmates" privacy dropdown option',
		defaultMessage: 'Only visible to my course peers, administrators, and facilitators.',
	},
	TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_PUBLIC_LABEL_TEXT: {
		id: 'TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_PUBLIC_LABEL_TEXT',
		description: 'Label text for the "public" privacy dropdown option',
		defaultMessage: 'Public',
	},
	TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_PUBLIC_HELP_TEXT: {
		id: 'TC_COMPONENTS_FORM_INPUT_PRIVACY_OPTION_PUBLIC_HELP_TEXT',
		description: 'Help text for the "public" privacy dropdown option',
		defaultMessage: 'Visible to any member of {org}.',
	},
	TC_COMPONENTS_VIDEO_INPUT_DELETE_MODAL_TITLE: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_DELETE_MODAL_TITLE',
		description: 'The title text for the modal to delete the video.',
		defaultMessage: 'Delete Video from Storage'
	},
	TC_COMPONENTS_VIDEO_INPUT_DELETE_MODAL_BODY: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_DELETE_MODAL_BODY',
		description: 'The body text for the modal to delete the video.',
		defaultMessage: 'Would you like to remove this video from storage? Choose "yes" if this video is not required in other session content. Chose "no" if you would like to retain this video for use in different content in the future.'
	},
	TC_COMPONENTS_VIDEO_INPUT_ADD_BUTTON_TEXT: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_ADD_BUTTON_TEXT',
		description: 'The label text for the button to create a video.',
		defaultMessage: 'Add Video'
	},
	TC_COMPONENTS_VIDEO_INPUT_EDIT_BUTTON_TEXT: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_EDIT_BUTTON_TEXT',
		description: 'The label text for the button to edit a video.',
		defaultMessage: 'Edit Video'
	},
	TC_COMPONENTS_VIDEO_INPUT_REMOVE_BUTTON_TEXT: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_REMOVE_BUTTON_TEXT',
		description: 'The label text for the button to remove a video.',
		defaultMessage: 'Remove Video'
	},
	TC_COMPONENTS_VIDEO_INPUT_MODAL_HEADER_EDIT_VIDEO: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_MODAL_HEADER_EDIT_VIDEO',
		description: 'The header text for the modal to edit a video.',
		defaultMessage: 'Edit Video'
	},
	TC_COMPONENTS_VIDEO_INPUT_MODAL_HEADER_CREATE_VIDEO: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_MODAL_HEADER_CREATE_VIDEO',
		description: 'The header text for the modal to create a video.',
		defaultMessage: 'Create Video'
	},
	TC_COMPONENTS_VIDEO_INPUT_SUBMIT_ERROR: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_SUBMIT_ERROR',
		description: 'Error message text for submitting the video input form.',
		defaultMessage: 'Error submitting video, please try again later.'
	},
	TC_COMPONENTS_VIDEO_INPUT_MASTER_ACCESS_ERROR: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_MASTER_ACCESS_ERROR',
		description: 'Error message text for requesting master access on the video input form.',
		defaultMessage: 'Error requesting master access video, please try again later.'
	},
	TC_COMPONENTS_VIDEO_INPUT_TITLE_FORM_FIELD_LABEL: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_TITLE_FORM_FIELD_LABEL',
		description: 'The label text for the form field to set the title.',
		defaultMessage: 'Title'
	},
	TC_COMPONENTS_VIDEO_INPUT_THUMBNAIL_FORM_FIELD_LABEL: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_THUMBNAIL_FORM_FIELD_LABEL',
		description: 'The label text for the form field to set a custom thumbnail timestamp.',
		defaultMessage: 'Thumbnail Timestamp'
	},
	TC_COMPONENTS_VIDEO_INPUT_THUMBNAIL_FORM_FIELD_HELP_TEXT: {
		id: 'TC_COMPONENTS_VIDEO_INPUT_THUMBNAIL_FORM_FIELD_HELP_TEXT',
		description: 'The help text for the form field to set a custom thumbnail timestamp.',
		defaultMessage: 'Choose a timestamp from the video, in seconds, to use as the thumbnail image.'
	},
	TC_COMPONENTS_FORM_FORM_FIELD_MASTER_ACCESS_BUTTON: {
		id: 'TC_COMPONENTS_FORM_FORM_FIELD_MASTER_ACCESS_BUTTON',
		description: 'The button label to request master access.',
		defaultMessage: 'Request Master Copy'
	},
	TC_COMPONENTS_FORM_FORM_FIELD_MASTER_ACCESS_LABEL: {
		id: 'TC_COMPONENTS_FORM_FORM_FIELD_MASTER_ACCESS_LABEL',
		description: 'The label for the master access form field.',
		defaultMessage: 'Master Access'
	},
	TC_COMPONENTS_FORM_FORM_FIELD_MASTER_ACCESS_HELP: {
		id: 'TC_COMPONENTS_FORM_FORM_FIELD_MASTER_ACCESS_HELP',
		description: 'The help text for the master access form field.',
		defaultMessage: 'Temporary link to download an original copy of the video, for editing or storage.'
	},
	TC_COMPONENTS_FORM_FIELD_MASTER_STATUS_PREPARING: {
		id: 'TC_COMPONENTS_FORM_FIELD_MASTER_STATUS_PREPARING',
		description: 'The status message when the master access is preparing.',
		defaultMessage: 'Master download is preparing....please check back in a few minutes!'
	},
	TC_COMPONENTS_FORM_TITLE_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_FORM: {
		id: 'TC_COMPONENTS_FORM_TITLE_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_FORM',
		description: 'The field placeholder text for a "form title" field.',
		defaultMessage: 'Form title'
	},
	TC_COMPONENTS_FORM_TITLE_DEFAULT: {
		id: 'TC_COMPONENTS_FORM_TITLE_DEFAULT',
		description: 'The default text for an untitled form',
		defaultMessage: 'Untitled Form'
	},
	TC_COMPONENTS_FORM_SECTION_TITLE_DEFAULT: {
		id: 'TC_COMPONENTS_FORM_SECTION_TITLE_DEFAULT',
		description: 'The default text for an untitled form section',
		defaultMessage: 'Untitled Section'
	},
	TC_COMPONENTS_FORM_TITLE_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_POLL: {
		id: 'TC_COMPONENTS_FORM_TITLE_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_POLL',
		description: 'The field placeholder text for a "poll title" field.',
		defaultMessage: 'Poll title'
	},
	TC_COMPONENTS_FORM_TITLE_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_QUIZ: {
		id: 'TC_COMPONENTS_FORM_TITLE_TEXT_FIELD_PLACEHOLDER_TEXT_FOR_QUIZ',
		description: 'The field placeholder text for a "quiz title" field.',
		defaultMessage: 'Quiz title'
	},
	TC_COMPONENTS_FORM_USER_PROFILE_EMPTY_MSG_IS_OTHER: {
		id: 'TC_COMPONENTS_FORM_USER_PROFILE_EMPTY_MSG_IS_OTHER',
		description: 'Message when the organization profile form is empty.',
		defaultMessage: 'There\'s no profile yet!',
	},
	TC_COMPONENTS_IMAGE_PICKER_BUTTON_TEXT_UPLOAD: {
		id: 'TC_COMPONENTS_IMAGE_PICKER_BUTTON_TEXT_UPLOAD',
		description: 'Button text for image upload',
		defaultMessage: 'Upload Image'
	},
	TC_COMPONENTS_IMAGE_PICKER_BUTTON_TEXT_CHANGE: {
		id: 'TC_COMPONENTS_IMAGE_PICKER_BUTTON_TEXT_CHANGE',
		description: 'Button text for changing an image',
		defaultMessage: 'Change Image'
	},
	TC_COMPONENTS_IMAGE_PICKER_BUTTON_TEXT_REMOVE: {
		id: 'TC_COMPONENTS_IMAGE_PICKER_BUTTON_TEXT_REMOVE',
		description: 'Button text for removing an image',
		defaultMessage: 'Remove'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_BUTTON_TEXT_ADD_CONTENT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_BUTTON_TEXT_ADD_CONTENT',
		description: 'The button text for adding new content.',
		defaultMessage: 'Add content',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_EMBED: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_EMBED',
		description: 'The label text for "embed" content.',
		defaultMessage: 'Embed',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_EMBED: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_EMBED',
		description: 'The description text for "embed" content.',
		defaultMessage: 'Embeddable content (Articulate, Iframe, PDF, etc.)',
	},
	TC_COMPONENTS_POINT_SETTINGS_LOADING_ERROR: {
		id: 'TC_COMPONENTS_POINT_SETTINGS_LOADING_ERROR',
		description: 'Error message for loading point settings',
		defaultMessage: 'There was an error loading the point settings. Please try again later.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DROPDOWN_GROUP_LEGEND_INTEGRATIONS: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DROPDOWN_GROUP_LEGEND_INTEGRATIONS',
		description: 'The legend text for the "integrations" group in the content builder dropdown menu.',
		defaultMessage: 'Integrations',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DROPDOWN_GROUP_LEGEND_CONTENT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DROPDOWN_GROUP_LEGEND_CONTENT',
		description: 'The legend text for the "content" group in the content builder dropdown menu.',
		defaultMessage: 'Content',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_FORM: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_FORM',
		description: 'The label text for "form" content.',
		defaultMessage: 'Form',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_FORM: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_FORM',
		description: 'The description text for "form" content.',
		defaultMessage: 'Collect information from learners',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_IMAGE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_IMAGE',
		description: 'The label text for "image" content.',
		defaultMessage: 'Image',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_IMAGE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_IMAGE',
		description: 'The description text for "image" content.',
		defaultMessage: 'Upload or choose from Dropbox, Google Drive, and others',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_MIRO: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_MIRO',
		description: 'The label text for "miro" content.',
		defaultMessage: 'Miro',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_MIRO: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_MIRO',
		description: 'The description text for "miro" content.',
		defaultMessage: 'Easily collaborate using a visual whiteboard and sticky notes',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_POLL: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_POLL',
		description: 'The label text for "poll" content.',
		defaultMessage: 'Poll',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_POLL: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_POLL',
		description: 'The description text for "poll" content.',
		defaultMessage: 'Real-time, Q&A Polling',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_QUIZ: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_QUIZ',
		description: 'The label text for "quiz" content.',
		defaultMessage: 'Quiz',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_QUIZ: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_QUIZ',
		description: 'The description text for "quiz" content.',
		defaultMessage: 'Test learner knowledge and understanding',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_SLIDE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_SLIDE',
		description: 'The label text for "slide" content.',
		defaultMessage: 'Slide',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_SLIDE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_SLIDE',
		description: 'The description text for "slide" content.',
		defaultMessage: 'Rich text and embedded links',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_VIDEO: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_LABEL_TEXT_VIDEO',
		description: 'The label text for "video" content.',
		defaultMessage: 'Video',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_VIDEO: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DESCRIPTION_TEXT_VIDEO',
		description: 'The description text for "video" content.',
		defaultMessage: 'Upload from a file or link to a hosted video',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_LABEL_TEXT_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_LABEL_TEXT_TITLE',
		description: 'The field label for the embed "title" fields',
		defaultMessage: 'Title'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_EDITOR_MSG_TEXT_ARTICULATE_UPLOAD_ERROR: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_EDITOR_MSG_TEXT_ARTICULATE_UPLOAD_ERROR',
		description: 'Error message text for saving the embed editor due to an articulate application upload error',
		defaultMessage: 'Error uploading the articulate, please try again later.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_LABEL_TEXT_SRC: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_LABEL_TEXT_SRC',
		description: 'The field label for the embed "src" fields',
		defaultMessage: 'Embed Url'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_PLACEHOLDER_TEXT_SRC: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_PLACEHOLDER_TEXT_SRC',
		description: 'The field placeholder text for the embed "src" fields',
		defaultMessage: 'Add a link here (ex. https://www.techchange.org/test-file.pdf)'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_LABEL_TEXT_ASPECT_RATIO: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_LABEL_TEXT_ASPECT_RATIO',
		description: 'The field label for the embed "aspect ratio" fields',
		defaultMessage: 'Aspect Ratio'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_HELP_TEXT_ASPECT_RATIO: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_HELP_TEXT_ASPECT_RATIO',
		description: 'The field helper text for the embed "aspect ratio" fields',
		defaultMessage: 'Most embeds are 16:9, but older embeds and some other things might require a slightly different aspect ratio.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_LABEL_TEXT_ARTICULATE_UPLOAD: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_LABEL_TEXT_ARTICULATE_UPLOAD',
		description: 'The field label for the embed "articulate upload" fields',
		defaultMessage: 'Upload Articulate'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_HELP_TEXT_ARTICULATE_UPLOAD: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_EMBED_FIELD_HELP_TEXT_ARTICULATE_UPLOAD',
		description: 'The field helper text for the embed "articulate upload" fields',
		defaultMessage: 'The articulate application will be uploaded to the TechChange CDN and embedded on the page'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_MIRO_FIELD_LABEL_TEXT_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_MIRO_FIELD_LABEL_TEXT_TITLE',
		description: 'The field label for the miro "title" fields',
		defaultMessage: 'Title'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_MIRO_BUTTON_TEXT_BOARD: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_MIRO_BUTTON_TEXT_BOARD',
		description: 'The label text for the button to choose a Miro board',
		defaultMessage: 'Choose Miro Board'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_MIRO_EMBED_PREVIEW_BUTTON_ARIA_LABEL: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_MIRO_EMBED_PREVIEW_BUTTON_ARIA_LABEL',
		description: 'The aria-label text for the button to change the selected Miro board',
		defaultMessage: 'Change Miro Board'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_BUTTON_TEXT_CHANGE_FORM_ENTRY: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_BUTTON_TEXT_CHANGE_FORM_ENTRY',
		description: 'Button text for the link to change the form entry for the form.',
		defaultMessage: 'Change answers',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_BUTTON_TEXT_SUBMIT_ANOTHER_FORM_ENTRY: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_BUTTON_TEXT_SUBMIT_ANOTHER_FORM_ENTRY',
		description: 'Button text for the link to submit another form entry for the form.',
		defaultMessage: 'Submit another response',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_BUTTON_TEXT_VIEW_FORM_ENTRIES: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_BUTTON_TEXT_VIEW_FORM_ENTRIES',
		description: 'Button text for the link to view the form entries for the form.',
		defaultMessage: 'View all responses',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_BUTTON_TITLE_TEXT_VIEW_FORM_ENTRIES: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_BUTTON_TITLE_TEXT_VIEW_FORM_ENTRIES',
		description: 'Button title text on hover for the link to view the form entries for the form.',
		defaultMessage: 'Click to view the form responses for all learners (opens a new tab).',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_PAGINATION_BUTTON_TEXT_GO_TO_FORM_ENTRY: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_PAGINATION_BUTTON_TEXT_GO_TO_FORM_ENTRY',
		description: 'Button text for the paginated buttons to view each of your responses for the form.',
		defaultMessage: 'Response {number}',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_PAGINATION_BUTTON_TEXT_GO_TO_QUIZ_ATTEMPT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_PAGINATION_BUTTON_TEXT_GO_TO_QUIZ_ATTEMPT',
		description: 'Button text for the paginated buttons to view each of your attempts for the quiz.',
		defaultMessage: 'Submission {number}',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_PAGINATION_BUTTON_GROUP_ARIAL_LABEL_TEXT_GO_TO_FORM_ENTRIES: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_PAGINATION_BUTTON_GROUP_ARIAL_LABEL_TEXT_GO_TO_FORM_ENTRIES',
		description: 'Button aria-label (accessibility) text for the paginated buttons to view each of your responses for the form.',
		defaultMessage: 'View your responses for the form',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_PAGINATION_BUTTON_GROUP_ARIAL_LABEL_TEXT_GO_TO_QUIZ_ATTEMPTS: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_PAGINATION_BUTTON_GROUP_ARIAL_LABEL_TEXT_GO_TO_QUIZ_ATTEMPTS',
		description: 'Button aria-label (accessibility) text for the paginated buttons to view each of your attempts for the quiz.',
		defaultMessage: 'View your submissions for the quiz',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_MSG_TEXT_SUBMIT_ERROR: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_MSG_TEXT_SUBMIT_ERROR',
		description: 'Error message text for submitting a form entry for a form',
		defaultMessage: 'Error while saving your response, please try again later.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_MSG_TEXT_SUBMIT_SUCCESS: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_ENTRY_MSG_TEXT_SUBMIT_SUCCESS',
		description: 'Success message text for submitting a form entry for a form',
		defaultMessage: 'Thanks for submitting your response!'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_MSG_TEXT_SAVE_ERROR: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_SAVE_ERROR',
		description: 'Error message text for saving the form editor',
		defaultMessage: 'Error while saving the form, please try again later.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_MSG_TEXT_OPTIONS_REQUIRED: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_MSG_TEXT_OPTIONS_REQUIRED',
		description: 'Error message text for missing valid options of a form_field_option in the form editor',
		defaultMessage: 'The question requires at least 2 options.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION',
		description: 'The button text for the "add new question" button dropdown in the form editor',
		defaultMessage: 'Add question to form'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_CLONE_QUESTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_CLONE_QUESTION',
		description: 'The hover text for the "create a copy of the question" button in the form editor',
		defaultMessage: 'Create a copy of the question'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_ARIA_LABEL_CLONE_QUESTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_ARIA_LABEL_CLONE_QUESTION',
		description: 'The aria label for the "create a copy of the question" button in the form editor',
		defaultMessage: 'Create a copy of the question {field_title}'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_MOVE_QUESTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_MOVE_QUESTION',
		description: 'The hover text for the "move question" drag-and-drop button in the form editor',
		defaultMessage: 'Move the question'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_REMOVE_QUESTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_REMOVE_QUESTION',
		description: 'The hover text for the "remove question" button in the form editor',
		defaultMessage: 'Remove the question'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_ARIA_LABEL_REMOVE_QUESTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_ARIA_LABEL_REMOVE_QUESTION',
		description: 'The aria label for the "remove question" button in the form editor',
		defaultMessage: 'Remove the question {field_title}'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_REQUIRED_QUESTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_REQUIRED_QUESTION',
		description: 'The hover text for the "required question" switch in the form editor',
		defaultMessage: 'Make the question required'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_MOVE_SECTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_MOVE_SECTION',
		description: 'The hover text for the "move section" drag-and-drop button in the form editor',
		defaultMessage: 'Move the section'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_REMOVE_SECTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_REMOVE_SECTION',
		description: 'The hover text for the "remove question" button in the form editor',
		defaultMessage: 'Remove the section'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_ADD_OPTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_ADD_OPTION',
		description: 'The hover text for the "add option" button for form fields in the form editor',
		defaultMessage: 'Add option'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_MOVE_OPTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_MOVE_OPTION',
		description: 'The hover text for the "move option" drag-and-drop button for form fields in the form editor',
		defaultMessage: 'Move option'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_REMOVE_OPTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_HOVER_TEXT_REMOVE_OPTION',
		description: 'The hover text for the "remove option" button for form fields in the form editor',
		defaultMessage: 'Remove option'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_MSG_TEXT_WARNING: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_MSG_TEXT_WARNING',
		description: 'The warning text for making changes in the form editor',
		defaultMessage: 'Users have already submitted entries for this form. Modifying the form could result in inconsistent data across entries.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_TEXT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_TEXT',
		description: 'The input placeholder text for the preview "text" input form fields in the form editor',
		defaultMessage: 'Short answer text'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_TEXTAREA: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_TEXTAREA',
		description: 'The input placeholder text for the preview "textarea" input form fields in the form editor',
		defaultMessage: 'Long answer text'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_EMAIL: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_EMAIL',
		description: 'The input placeholder text for the preview "email" input form fields in the form editor',
		defaultMessage: 'Email text'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_FILE_UPLOAD: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_INPUT_PLACEHOLDER_TEXT_DUMMY_FILE_UPLOAD',
		description: 'The input placeholder text for the preview "file upload" input form fields in the form editor',
		defaultMessage: 'Choose File'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_TITLE',
		description: 'The field placeholder text for the "title" field in the form editor',
		defaultMessage: 'Form title'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_DESCRIPTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_DESCRIPTION',
		description: 'The field placeholder text for the "description" field in the form editor',
		defaultMessage: 'Form description'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_TITLE',
		description: 'The field placeholder text for the "title" field for a form field in the form editor',
		defaultMessage: 'Question'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_HELP: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_HELP',
		description: 'The field placeholder text for the "help" field for a form field in the form editor',
		defaultMessage: 'Description'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_LEGEND: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_LEGEND',
		description: 'The field placeholder text for the "legend" field for a form section in the form editor',
		defaultMessage: 'Section title'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_DESCRIPTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_SECTION_DESCRIPTION',
		description: 'The field placeholder text for the "description" field for a form section in the form editor',
		defaultMessage: 'Section description'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_LABEL_TEXT_FORM_FIELD_REQUIRED: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_LABEL_TEXT_FORM_FIELD_REQUIRED',
		description: 'The field label text for the "required" field for a form field in the form editor',
		defaultMessage: 'Required'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_OPTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_OPTION',
		description: 'The field placeholder text value for the "form_field_option" field for a form field in the form editor',
		defaultMessage: 'Option {index}'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_OPTION_LIKERT_SCALE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FORM_EDITOR_FIELD_PLACEHOLDER_TEXT_FORM_FIELD_OPTION_LIKERT_SCALE',
		description: 'The field placeholder text value for the "form_field_option" field for a likert scale form field in the form editor',
		defaultMessage: 'Label (optional)'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_BUTTON_TEXT_CHANGE_IMAGE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_BUTTON_TEXT_CHANGE_IMAGE',
		description: 'The text for the "change image" button',
		defaultMessage: 'Change Image'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_BUTTON_TEXT_UPLOAD_IMAGE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_BUTTON_TEXT_UPLOAD_IMAGE',
		description: 'The text for the "upload image" button',
		defaultMessage: 'Upload Image'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_LABEL_TEXT_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_LABEL_TEXT_TITLE',
		description: 'The field label for the image "title" field',
		defaultMessage: 'Title'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_PLACEHOLDER_TEXT_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_PLACEHOLDER_TEXT_TITLE',
		description: 'The field placeholder text for the image "title" field',
		defaultMessage: 'Title'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_LABEL_TEXT_IMAGE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_LABEL_TEXT_IMAGE',
		description: 'The field label for the image "image" field',
		defaultMessage: 'Image'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_LABEL_TEXT_ALT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_LABEL_TEXT_ALT',
		description: 'The field label for the image "alt text" fields',
		defaultMessage: 'Description'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_PLACEHOLDER_TEXT_ALT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_PLACEHOLDER_TEXT_ALT',
		description: 'The field placeholder text for the image "alt text" fields',
		defaultMessage: 'Description'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_HELP_TEXT_ALT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_HELP_TEXT_ALT',
		description: 'The field helper text for the image "alt text" fields',
		defaultMessage: 'A description helps improve accessibility and 508 compliance.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_LABEL_TEXT_LINK_TARGET: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_LABEL_TEXT_LINK_TARGET',
		description: 'The field label for the image link "target" fields',
		defaultMessage: 'Target'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_LABEL_TEXT_HREF: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_LABEL_TEXT_HREF',
		description: 'The field label for the image "href" fields',
		defaultMessage: 'Link'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_PLACEHOLDER_TEXT_HREF: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_IMAGE_FIELD_PLACEHOLDER_TEXT_HREF',
		description: 'The field placeholder text for the image "href" fields',
		defaultMessage: 'Link your image to other content'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_LABEL_TEXT_ASPECT_RATIO: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_LABEL_TEXT_ASPECT_RATIO',
		description: 'The field label for the video "aspect ratio" fields',
		defaultMessage: 'Aspect Ratio'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_HELP_TEXT_ASPECT_RATIO: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_HELP_TEXT_ASPECT_RATIO',
		description: 'The field helper text for the video "aspect ratio" fields',
		defaultMessage: 'Most videos are 16:9, but older videos and some other things might require a slightly different aspect ratio.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_LABEL_TEXT_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_LABEL_TEXT_TITLE',
		description: 'The field label for the video "title" fields',
		defaultMessage: 'Title'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_LABEL_PROVIDER: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_LABEL_PROVIDER',
		description: 'The field label for the video "provider" fields',
		defaultMessage: 'Video'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_HELP_PROVIDER: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_HELP_PROVIDER',
		description: 'The field help text for the video "provider" fields',
		defaultMessage: 'Choose how to store a video'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_PROVIDER_OPTIONS_LABEL_URL: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_PROVIDER_OPTIONS_LABEL_URL',
		description: 'The option label for the video "provider" fields option "URL"',
		defaultMessage: 'Link'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_PROVIDER_OPTIONS_LABEL_LIBRARY: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_PROVIDER_OPTIONS_LABEL_LIBRARY',
		description: 'The option label for the video "provider" fields option "Library"',
		defaultMessage: 'Upload'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_LABEL_TEXT_VIDEO_ID: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_LABEL_TEXT_VIDEO_ID',
		description: 'The field label for the video "video_id" fields',
		defaultMessage: 'Video Upload'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_PLACEHOLDER_TEXT_VIDEO_ID: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_PLACEHOLDER_TEXT_VIDEO_ID',
		description: 'The field placeholder text for the video "video" fields',
		defaultMessage: 'Upload a video from your computer'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_LABEL_TEXT_SRC: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_LABEL_TEXT_SRC',
		description: 'The field label for the video "src" fields',
		defaultMessage: 'Video Url'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_PLACEHOLDER_TEXT_SRC: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_PLACEHOLDER_TEXT_SRC',
		description: 'The field placeholder text for the video "video" fields',
		defaultMessage: 'Add a video link here (ex. https://www.youtube.com/watch?v=ZhHYYdlGx1A)'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_PLACEHOLDER_TEXT_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_VIDEO_FIELD_PLACEHOLDER_TEXT_TITLE',
		description: 'The field placeholder text for the video "title" fields',
		defaultMessage: 'Title of the video'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_ENTRY_VIEW_RESULTS: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_ENTRY_VIEW_RESULTS',
		description: 'Link text for clicking to view the aggregated results for a poll',
		defaultMessage: 'View poll results'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_ENTRY_MSG_TEXT_SUBMIT_ERROR: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_ENTRY_MSG_TEXT_SUBMIT_ERROR',
		description: 'Error message text for submitting a form entry for a poll',
		defaultMessage: 'Error while saving the entry for the poll, please try again later.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_ENTRY_MSG_TEXT_SUBMIT_SUCCESS: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_ENTRY_MSG_TEXT_SUBMIT_SUCCESS',
		description: 'Success message text for submitting a form entry for a poll',
		defaultMessage: 'Thanks for submitting your entry for the poll!'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION',
		description: 'The button text for the "add new question" button dropdown in the poll editor',
		defaultMessage: 'Add question to poll'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_EDITOR_MSG_TEXT_WARNING: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_EDITOR_MSG_TEXT_WARNING',
		description: 'The warning text for making changes in the poll editor',
		defaultMessage: 'Users have already submitted entries for this poll. Modifying the poll could result in inconsistent data across entries.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_EDITOR_FIELD_PLACEHOLDER_TEXT_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_EDITOR_FIELD_PLACEHOLDER_TEXT_TITLE',
		description: 'The field placeholder text for the "title" field in the poll editor',
		defaultMessage: 'Poll title'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_EDITOR_FIELD_PLACEHOLDER_TEXT_DESCRIPTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_POLL_EDITOR_FIELD_PLACEHOLDER_TEXT_DESCRIPTION',
		description: 'The field placeholder text for the "description" field in the poll editor',
		defaultMessage: 'Poll description'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_LABEL_TEXT_CORRECT_ANSWER: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_LABEL_TEXT_CORRECT_ANSWER',
		description: 'The label text for the list of correct answers in the quiz results display',
		defaultMessage: 'Correct answer'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_ICON_LABEL_CORRECT_ANSWER: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_ICON_LABEL_CORRECT_ANSWER',
		description: 'The aria label for the checkmark',
		defaultMessage: 'Correct'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_ICON_LABEL_INCORRECT_ANSWER: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_ICON_LABEL_INCORRECT_ANSWER',
		description: 'The aria label for the X icon',
		defaultMessage: 'Incorrect'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_ICON_LABEL_MISSING_ANSWER: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_ICON_LABEL_MISSING_ANSWER',
		description: 'The aria label for the missing answer icon',
		defaultMessage: 'Missing answer'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_LABEL_TEXT_FEEDBACK: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_LABEL_TEXT_FEEDBACK',
		description: 'The label text for the correct/incorrect customized feedback in the quiz results display',
		defaultMessage: 'Feedback'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_BUTTON_TEXT_VIEW_SUBMISSIONS: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_BUTTON_TEXT_VIEW_SUBMISSIONS',
		description: 'Button text for the link to view the settings page with a list of all submissions for the quiz.',
		defaultMessage: 'View all submissions',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_BUTTON_TITLE_TEXT_VIEW_SUBMISSIONS: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_BUTTON_TITLE_TEXT_VIEW_SUBMISSIONS',
		description: 'Button hover title text for the link to view the settings page with a list of all submissions for the quiz.',
		defaultMessage: 'Click to view the quiz submissions for all learners (opens a new tab).',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_FAILED_QUIZ_PREFIX: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_FAILED_QUIZ_PREFIX',
		description: 'Error prefix message text for failing a quiz',
		defaultMessage: 'Oops!'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_FAILED_QUIZ: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_FAILED_QUIZ',
		description: 'Error message text for failing a quiz',
		defaultMessage: 'You did not pass the quiz.'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_FAILED_QUIZ_RETRY_PROMPT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_FAILED_QUIZ_RETRY_PROMPT',
		description: 'Button text to prompt the learner to retry with a new submission after failing the quiz',
		defaultMessage: 'Try again'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_PASSED_QUIZ_PREFIX: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_PASSED_QUIZ_PREFIX',
		description: 'Success prefix message text for passing a quiz',
		defaultMessage: 'Congratulations!'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_PASSED_QUIZ: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_PASSED_QUIZ',
		description: 'Success message text for passing a quiz',
		defaultMessage: 'You passed the quiz!'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_YOUR_SCORE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_YOUR_SCORE',
		description: 'Message label text for displaying the score for the learner\'s quiz attempt',
		defaultMessage: 'Your score'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_REQUIRED_SCORE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_REQUIRED_SCORE',
		description: 'Message label text for displaying the required score to pass the quiz',
		defaultMessage: 'Required score'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_NUM_CORRECT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_NUM_CORRECT',
		description: 'Message text for displaying the number of correct answers for the learner\'s quiz attempt',
		defaultMessage: '{numCorrect} of {numQuestions}'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_NUM_CORRECT_LABEL: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_DISPLAY_RESULTS_MSG_TEXT_NUM_CORRECT_LABEL',
		description: 'Message label text for displaying the number of correct answers for the learner\'s quiz attempt',
		defaultMessage: 'correct answers'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_BUTTON_TEXT_ADD_NEW_QUESTION',
		description: 'The button text for the "add new question" button dropdown in the quiz editor',
		defaultMessage: 'Add question to quiz'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_FIELD_PLACEHOLDER_TEXT_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_FIELD_PLACEHOLDER_TEXT_TITLE',
		description: 'The field placeholder text for the "title" field in the quiz editor',
		defaultMessage: 'Quiz title'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_FIELD_PLACEHOLDER_TEXT_DESCRIPTION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_FIELD_PLACEHOLDER_TEXT_DESCRIPTION',
		description: 'The field placeholder text for the "description" field in the quiz editor',
		defaultMessage: 'Quiz description'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_ACTION_TEXT_CHOOSE_ANSWERS_AND_FEEDBACK: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_ACTION_TEXT_CHOOSE_ANSWERS_AND_FEEDBACK',
		description: 'The icon/hover text for choosing the answers and feedback for a field in the quiz editor',
		defaultMessage: 'Choose answers & feedback'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_CHOOSE_ANSWER_AND_FEEDBACK_MODAL_ANSWER_HEADER: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_CHOOSE_ANSWER_AND_FEEDBACK_MODAL_ANSWER_HEADER',
		description: 'The header text for the modal to "choose correct answers" for a field in the quiz editor',
		defaultMessage: 'Choose correct answers'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_CHOOSE_ANSWER_AND_FEEDBACK_MODAL_FEEDBACK_HEADER: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_CHOOSE_ANSWER_AND_FEEDBACK_MODAL_FEEDBACK_HEADER',
		description: 'The header text for the modal to "choose answer feedback" for a field in the quiz editor',
		defaultMessage: 'Choose answer feedback'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_FIELD_LABEL_TEXT_SUBMISSION_FEEDBACK_CORRECT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_FIELD_LABEL_TEXT_SUBMISSION_FEEDBACK_CORRECT',
		description: 'The field label text for the "submission feedback correct" for a field in the quiz editor',
		defaultMessage: 'Feedback for correct answer'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_FIELD_LABEL_TEXT_SUBMISSION_FEEDBACK_INCORRECT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_QUIZ_EDITOR_FIELD_LABEL_TEXT_SUBMISSION_FEEDBACK_INCORRECT',
		description: 'The field label text for the "submission feedback incorrect" for a field in the quiz editor',
		defaultMessage: 'Feedback for incorrect answer'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_SLIDE_FIELD_LABEL_TEXT_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_SLIDE_FIELD_LABEL_TEXT_TITLE',
		description: 'The field label text for the "title" field of a slide',
		defaultMessage: 'Title'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_SLIDE_FIELD_PLACEHOLDER_TEXT_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_SLIDE_FIELD_PLACEHOLDER_TEXT_TITLE',
		description: 'The field placeholder text for the "title" field of a slide',
		defaultMessage: 'Title of the slide'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_SLIDE_FIELD_LABEL_TEXT_CONTENT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_SLIDE_FIELD_LABEL_TEXT_CONTENT',
		description: 'The field label text for the "content" field of a slide',
		defaultMessage: 'Content'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_SLIDE_FIELD_PLACEHOLDER_TEXT_CONTENT: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_SLIDE_FIELD_PLACEHOLDER_TEXT_CONTENT',
		description: 'The field placeholder text for the "content" field of a slide',
		defaultMessage: 'Slide content'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DELETE_CONFIRMATION_HEADER_TRANSLATION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DELETE_CONFIRMATION_HEADER_TRANSLATION',
		description: 'The header text for the delete confirmation modal when removing a translation',
		defaultMessage: 'Delete Translation',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DELETE_CONFIRMATION_BODY_TRANSLATION: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_DELETE_CONFIRMATION_BODY_TRANSLATION',
		description: 'The body text for the delete confirmation modal when removing a translation',
		defaultMessage: 'Are you sure want to delete this translation?',
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_HELPER_TEXT_TRANSLATION_ADD: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_HELPER_TEXT_TRANSLATION_ADD',
		description: 'The helper text for adding a new resource translation',
		defaultMessage: 'There is no {language} translation for this slide.\nWould you like to add one?'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_BUTTON_LABEL_TEXT_TRANSLATION_ADD: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_BUTTON_LABEL_TEXT_TRANSLATION_ADD',
		description: 'The button label for adding a new resource translation',
		defaultMessage: 'Add Translation'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_BUTTON_LABEL_TEXT_TRANSLATION_DELETE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_BUTTON_LABEL_TEXT_TRANSLATION_DELETE',
		description: 'The button label for deleting a resource translation',
		defaultMessage: 'Delete Translation'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FIELD_LABEL_TEXT_LANGUAGE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FIELD_LABEL_TEXT_LANGUAGE',
		description: 'The field label for language fields',
		defaultMessage: 'Language'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FIELD_LABEL_TEXT_WIDTH: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_FIELD_LABEL_TEXT_WIDTH',
		description: 'The field label for width fields',
		defaultMessage: 'Width'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_21_BY_9: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_21_BY_9',
		description: 'The option label for "21by9" aspect ratio',
		defaultMessage: '21:9'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_2_BY_1: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_2_BY_1',
		description: 'The option label for "2by1" aspect ratio',
		defaultMessage: '2:1'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_16_BY_9: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_16_BY_9',
		description: 'The option label for "16by9" aspect ratio',
		defaultMessage: '16:9'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_5_BY_4: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_5_BY_4',
		description: 'The option label for "5by4" aspect ratio',
		defaultMessage: '5:4'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_4_BY_3: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_4_BY_3',
		description: 'The option label for "4by3" aspect ratio',
		defaultMessage: '4:3'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_1_BY_1: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_ASPECT_RATIO_LABEL_TEXT_1_BY_1',
		description: 'The option label for "1by1" aspect ratio',
		defaultMessage: '1:1'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_LINK_TARGET_LABEL_TEXT_NEW_WINDOW: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_LINK_TARGET_LABEL_TEXT_NEW_WINDOW',
		description: 'The option label for "new window" link target',
		defaultMessage: 'New Window'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_LINK_TARGET_LABEL_TEXT_NONE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_LINK_TARGET_LABEL_TEXT_NONE',
		description: 'The option label for "self" link target',
		defaultMessage: 'None'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_FULL: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_FULL',
		description: 'The option label for "full" width',
		defaultMessage: 'Full'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_THREE_FOURTHS: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_THREE_FOURTHS',
		description: 'The option label for "3/4" width',
		defaultMessage: '3/4'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_TWO_THIRDS: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_TWO_THIRDS',
		description: 'The option label for "2/3" width',
		defaultMessage: '2/3'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_HALF: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_HALF',
		description: 'The option label for "1/2" width',
		defaultMessage: '1/2'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_ONE_THIRD: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_ONE_THIRD',
		description: 'The option label for "1/3" width',
		defaultMessage: '1/3'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_ONE_FOURTH: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_BUILDER_OPTION_WIDTH_LABEL_TEXT_ONE_FOURTH',
		description: 'The option label for "1/4" width',
		defaultMessage: '1/4'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_ARIA_LABEL_DRAG: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_ARIA_LABEL_DRAG',
		description: 'Button aria-label text for "drag" button in resource toolbars',
		defaultMessage: 'Move {title}'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_TITLE_DRAG: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_TITLE_DRAG',
		description: 'Button title text for "drag" button in resource toolbars',
		defaultMessage: 'Move content'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_ARIA_LABEL_VIEW_TOOLBAR: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_ARIA_LABEL_VIEW_TOOLBAR',
		description: 'Button aria-label text for "view toolbar" button in resource toolbars',
		defaultMessage: 'Open toolbar for {title}'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_TITLE_VIEW_TOOLBAR: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_TITLE_VIEW_TOOLBAR',
		description: 'Button title text for "view toolbar" button in resource toolbars',
		defaultMessage: 'Open toolbar'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_ARIA_LABEL_VIEW_REQUIREMENTS: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_ARIA_LABEL_VIEW_REQUIREMENTS',
		description: 'Button aria-label text for "show requirements" button',
		defaultMessage: 'Show requirements for {title}'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_TITLE_VIEW_REQUIREMENTS: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_GRID_BUTTON_TITLE_VIEW_REQUIREMENTS',
		description: 'Button title text for "show requirements" button',
		defaultMessage: 'Show requirements'
	},
	TC_COMPONENTS_RESOURCE_CONTENT_GRID_ERROR_MSG_SAVE_RESOURCE_WITH_TYPE: {
		id: 'TC_COMPONENTS_RESOURCE_CONTENT_GRID_ERROR_MSG_SAVE_RESOURCE_WITH_TYPE',
		description: 'Error message text for saving a resource',
		defaultMessage: 'Error while saving the {type}, please try again later.'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_HEADER: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_HEADER',
		description: 'The header text for the settings editor modal',
		defaultMessage: 'Edit settings for {title}'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_ERROR_MSG_SAVE_RESOURCE_SETTINGS: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_ERROR_MSG_SAVE_RESOURCE_SETTINGS',
		description: 'Error message text for saving the settings of a resource',
		defaultMessage: 'Error while saving the settings, please try again later.'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_RESOURCE_ID_LABEL_TEXT: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_RESOURCE_ID_LABEL_TEXT',
		description: 'The label text for the resource ID display',
		defaultMessage: 'Resource ID:'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_PREFERENCES_LABEL_TEXT: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_PREFERENCES_LABEL_TEXT',
		description: 'The label text for the preferences section of the settings editor modal',
		defaultMessage: 'Preferences'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_QUIZ_PASS_PERCENTAGE: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_QUIZ_PASS_PERCENTAGE',
		description: 'The field label for choosing the pass percentage required for a quiz',
		defaultMessage: 'Pass percentage'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_QUIZ_SHOW_CORRECT_ANSWERS: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_QUIZ_SHOW_CORRECT_ANSWERS',
		description: 'The field label for toggle on/off the ability for learners to see the quiz correct answers after submission.',
		defaultMessage: 'Show correct answers after response is submitted'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_SHOW_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_SHOW_TITLE',
		description: 'The field label for showing/hiding title fields',
		defaultMessage: 'Show the title'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_ALLOW_EDITING_SUBMISSIONS: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_ALLOW_EDITING_SUBMISSIONS',
		description: 'The field label for toggle on/off the ability for learners to edit their form submission',
		defaultMessage: 'Allow editing responses'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_ALLOW_MULTIPLE_SUBMISSIONS: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_ALLOW_MULTIPLE_SUBMISSIONS',
		description: 'The field label for toggle on/off the ability for learners to have multiple form submissions',
		defaultMessage: 'Allow multiple responses'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_HELP_TEXT_SHOW_TITLE: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_HELP_TEXT_SHOW_TITLE',
		description: 'The field help text for show_title fields',
		defaultMessage: 'Choose visibility of {type} title.'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_SELF_REPORTING: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_SELF_REPORTING',
		description: 'The field label for self reporting detailed fields',
		defaultMessage: 'Self reporting'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_HELP_TEXT_SELF_REPORTING: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_HELP_TEXT_SELF_REPORTING',
		description: 'The field help text for self reporting fields',
		defaultMessage: 'Allow participants to self-report completion for this {type}.'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_DEFAULT_CHILD: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_DEFAULT_CHILD',
		description: 'The field label for default_child_id fields',
		defaultMessage: 'Default child resource to display'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_OPEN_DATE: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_OPEN_DATE',
		description: 'The field label for open_date fields',
		defaultMessage: 'Open date'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_PRELABEL_TEXT_POINTS: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_PRELABEL_TEXT_POINTS',
		description: 'The field label for points fields',
		defaultMessage: 'Points to Award'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_DELETE_BUTTON: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_DELETE_BUTTON',
		description: 'The label for deleting content in the settings editor modal',
		defaultMessage: 'Delete this {type}'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_DELETE_LABEL_TEXT: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_DELETE_LABEL_TEXT',
		description: 'The label for deleting content in the settings editor modal',
		defaultMessage: 'Delete this {type}'
	},
	TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_DELETE_CONFIRMATION_TEXT: {
		id: 'TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_DELETE_CONFIRMATION_TEXT',
		description: 'The confirmation text for deleting content in the settings editor modal',
		defaultMessage: 'Once you delete a resource, there is no going back. Please be certain.'
	},
	TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_ARIA_LABEL_EDIT_CONTENT: {
		id: 'TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_ARIA_LABEL_EDIT_CONTENT',
		description: 'Button aria-label text for "edit content" button in resource toolbars',
		defaultMessage: 'Edit content for {title}'
	},
	TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_TITLE_EDIT_CONTENT: {
		id: 'TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_TITLE_EDIT_CONTENT',
		description: 'Button title text for "edit content" button in resource toolbars',
		defaultMessage: 'Edit content'
	},
	TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_ARIA_LABEL_EDIT_RULE: {
		id: 'TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_ARIA_LABEL_EDIT_RULE',
		description: 'Button aria-label text for "edit rule" button in resource toolbars',
		defaultMessage: 'Edit completion rule for {title}'
	},
	TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_TITLE_EDIT_RULE: {
		id: 'TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_TITLE_EDIT_RULE',
		description: 'Button title text for "edit rule" button in resource toolbars',
		defaultMessage: 'Edit completion rule'
	},
	TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_ARIA_LABEL_EDIT_SETTINGS: {
		id: 'TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_ARIA_LABEL_EDIT_SETTINGS',
		description: 'Button aria-label text for "edit settings" button in resource toolbars',
		defaultMessage: 'Edit settings for {title}'
	},
	TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_TITLE_EDIT_SETTINGS: {
		id: 'TC_COMPONENTS_RESOURCE_TOOLBAR_BUTTON_TITLE_EDIT_SETTINGS',
		description: 'Button title text for "edit settings" button in resource toolbars',
		defaultMessage: 'Edit settings'
	},
	TC_COMPONENTS_RULE_EDITOR_HEADER_TEXT: {
		id: 'TC_COMPONENTS_RULE_EDITOR_HEADER_TEXT',
		description: 'The section label text for the rule editor modal',
		defaultMessage: 'To complete this {type}, the learner must have:'
	},
	TC_COMPONENTS_RULE_EDITOR_ADDITIONAL_REQUIREMENTS_HEADER: {
		id: 'TC_COMPONENTS_RULE_EDITOR_ADDITIONAL_REQUIREMENTS_HEADER',
		description: 'The additional requirements section label text for the rule editor modal',
		defaultMessage: 'Additional requirements:'
	},
	TC_COMPONENTS_RULE_EDITOR_TEXT_NO_CONTENT_TO_COMPLETE: {
		id: 'TC_COMPONENTS_RULE_EDITOR_TEXT_NO_CONTENT_TO_COMPLETE',
		description: 'The text for "no children to complete" for the rule editor modal',
		defaultMessage: 'No content to complete.'
	},
	TC_COMPONENTS_RULE_EDITOR_FIELD_LABEL_TEXT_OPERATOR: {
		id: 'TC_COMPONENTS_RULE_EDITOR_FIELD_LABEL_TEXT_OPERATOR',
		description: 'The field label for rule operation fields',
		defaultMessage: 'Choose an operator'
	},
	TC_COMPONENTS_RULE_EDITOR_FIELD_OPTION_VALUE_OPERATOR_ANY: {
		id: 'TC_COMPONENTS_RULE_EDITOR_FIELD_OPTION_VALUE_OPERATOR_ANY',
		description: 'The field option label for "any" for rule operation fields',
		defaultMessage: 'any'
	},
	TC_COMPONENTS_RULE_EDITOR_FIELD_OPTION_VALUE_OPERATOR_ALL: {
		id: 'TC_COMPONENTS_RULE_EDITOR_FIELD_OPTION_VALUE_OPERATOR_ALL',
		description: 'The field option label for "all" for rule operation fields',
		defaultMessage: 'all'
	},
	TC_COMPONENTS_RULE_EDITOR_FIELD_LABEL_TEXT_COUNT: {
		id: 'TC_COMPONENTS_RULE_EDITOR_FIELD_LABEL_TEXT_COUNT',
		description: 'The field label for rule count fields',
		defaultMessage: 'Number of children to complete'
	},
	TC_COMPONENTS_RULE_EDITOR_ADDITIONAL_REQUIREMENTS_BUTTON_TEXT: {
		id: 'TC_COMPONENTS_RULE_EDITOR_ADDITIONAL_REQUIREMENTS_BUTTON_TEXT',
		description: 'The button label for adding another requirement',
		defaultMessage: 'Add requirement'
	},
	TC_COMPONENTS_RULE_EDITOR_FIELD_ACTIVE_LABEL_TEXT: {
		id: 'TC_COMPONENTS_RULE_EDITOR_FIELD_ACTIVE_LABEL_TEXT',
		description: 'The field label text for toggling a subcondition active',
		defaultMessage: 'Make subcondition #{index} active'
	},
	TC_COMPONENTS_RULE_EDITOR_FIELD_THRESHOLD_LABEL_TEXT: {
		id: 'TC_COMPONENTS_RULE_EDITOR_FIELD_THRESHOLD_LABEL_TEXT',
		description: 'The field label text for threshold values',
		defaultMessage: 'Please choose a threshold value (0-100) for completion of subcondition #{index}'
	},
	TC_COMPONENTS_RULE_EDITOR_FIELD_THRESHOLD_INVALID_TEXT: {
		id: 'TC_COMPONENTS_RULE_EDITOR_FIELD_THRESHOLD_INVALID_TEXT',
		description: 'The field error text for invalid threshold values',
		defaultMessage: 'Please enter a valid number'
	},
	TC_COMPONENTS_RULE_EDITOR_OBJECT_OPTION_ANY_THREAD: {
		id: 'TC_COMPONENTS_RULE_EDITOR_OBJECT_OPTION_ANY_THREAD',
		description: 'Select option label for any thread parent object',
		defaultMessage: 'Any thread'
	},
	TC_COMPONENTS_RULE_EDITOR_OBJECT_OPTION_ANY_TOPIC: {
		id: 'TC_COMPONENTS_RULE_EDITOR_OBJECT_OPTION_ANY_TOPIC',
		description: 'Select option label for any topic parent object',
		defaultMessage: 'Any topic'
	},
	TC_COMPONENTS_RULE_EDITOR_MODAL_HEADER_TEXT_EDIT: {
		id: 'TC_COMPONENTS_RULE_EDITOR_MODAL_HEADER_TEXT_EDIT',
		description: 'The header text for the rule editor "edit" modal',
		defaultMessage: 'Edit completion rule for {title}'
	},
	TC_COMPONENTS_RULE_EDITOR_MODAL_HEADER_TEXT_CREATE: {
		id: 'TC_COMPONENTS_RULE_EDITOR_MODAL_HEADER_TEXT_CREATE',
		description: 'The header text for the rule editor "create" modal',
		defaultMessage: 'New completion rule for {title}'
	},
	TC_COMPONENTS_RULE_EDITOR_MODAL_ERROR_MSG_SAVE_RULE: {
		id: 'TC_COMPONENTS_RULE_EDITOR_MODAL_ERROR_MSG_SAVE_RULE',
		description: 'Error message text for saving a rule',
		defaultMessage: 'Error while saving the rule, please try again later.'
	},
	TC_COMPONENTS_RULE_EDITOR_MODAL_SUCCESS_MSG_SAVE_RULE: {
		id: 'TC_COMPONENTS_RULE_EDITOR_MODAL_SUCCESS_MSG_SAVE_RULE',
		description: 'Success message text for saving a rule',
		defaultMessage: 'Rule updated successfully. Refresh the page to see your up-to-date completion tracking status.'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_DISCUSSION_COMMENT_CREATED: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_DISCUSSION_COMMENT_CREATED',
		description: 'Description for the requirement of creating a discussion comment',
		defaultMessage: 'Post a response'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_DISCUSSION_COMMENT_CREATED_PARENT: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_DISCUSSION_COMMENT_CREATED_PARENT',
		description: 'Description for the parent component of the requirement of creating a discussion comment',
		defaultMessage: 'in <anchor>{thread_title}</anchor>'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_DISCUSSION_THREAD_CREATED: {
		id: 'REQUIREMENTS_DESCRIPTION_DISCUSSION_THREAD_CREATED',
		description: 'Description for the requirement of creating a discussion thread',
		defaultMessage: 'Start a thread'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_DISCUSSION_THREAD_CREATED_PARENT: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_DISCUSSION_THREAD_CREATED_PARENT',
		description: 'Description for the parent component of the requirement of creating a discussion thread',
		defaultMessage: 'in <anchor>{topic_title}</anchor>'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_FORM_ENTRY_CREATED: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_FORM_ENTRY_CREATED',
		description: 'Description for the requirement of creating a form entry',
		defaultMessage: 'Submit a response'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_FORM_ENTRY_CREATED_PARENT: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_FORM_ENTRY_CREATED_PARENT',
		description: 'Description for the parent component of the requirement of creating a form entry',
		defaultMessage: 'to <anchor>{form_title}</anchor>'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_OBJECT_CLICKED: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_OBJECT_MARKED_CLICKED',
		description: 'Description for the requirement of clicking a generic object',
		defaultMessage: 'Click <anchor>{object_title}</anchor>'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_OBJECT_MARKED_COMPLETE: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_OBJECT_MARKED_COMPLETE',
		description: 'Description for the requirement of marking a generic object as complete',
		defaultMessage: 'Mark <anchor>{object_title}</anchor> as complete'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_OBJECT_COMPLETED: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_OBJECT_COMPLETED',
		description: 'Description for the requirement of completing a generic object',
		defaultMessage: 'Complete <anchor>{object_title}</anchor>'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_POINT_EARNED: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_POINT_EARNED',
		description: 'Description for the requirement of earning a point total',
		defaultMessage: 'Earn {point_total} points'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_QUIZ_PASSED: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_QUIZ_PASSED',
		description: 'Description for the requirement of passing a quiz',
		defaultMessage: 'Pass <anchor>{quiz_title}</anchor>'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_SESSION_COMPLETED: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_SESSION_COMPLETED',
		description: 'Description for the requirement of completing the session',
		defaultMessage: 'Complete the session'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_SLIDE_VIEWED: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_SLIDE_VIEWED',
		description: 'Description for the requirement of viewing the slide',
		defaultMessage: 'View {slide_title}'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_VIDEO_FINISHED: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_VIDEO_FINISHED',
		description: 'Description for the requirement of finishing the video',
		defaultMessage: 'Finish {video_title}'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_VIDEO_PAUSED: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_VIDEO_PAUSED',
		description: 'Description for the requirement of pausing the video',
		defaultMessage: 'Pause {video_title}'
	},
	TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_VIDEO_PLAYED: {
		id: 'TC_COMPONENTS_RULE_EDITOR_REQUIREMENT_DESCRIPTION_VIDEO_PLAYED',
		description: 'Description for the requirement of playing the video',
		defaultMessage: 'Play {video_title}'
	},
	TC_COMPONENTS_SELF_COMPLETE_BUTTON_COMPLETE: {
		id: 'TC_COMPONENTS_SELF_COMPLETE_BUTTON_COMPLETE',
		description: 'The label text for self report buttons that are already completed.',
		defaultMessage: 'Complete'
	},
	TC_COMPONENTS_SELF_COMPLETE_BUTTON_COMPLETE_ARIA_LABEL: {
		id: 'TC_COMPONENTS_SELF_COMPLETE_BUTTON_COMPLETE_ARIA_LABEL',
		description: 'The aria-label text for self report buttons that are already completed.',
		defaultMessage: '{title} has been marked complete'
	},
	TC_COMPONENTS_SELF_COMPLETE_BUTTON_MARK_COMPLETE: {
		id: 'TC_COMPONENTS_SELF_COMPLETE_BUTTON_MARK_COMPLETE',
		description: 'The label text for self report buttons that still need to be completed.',
		defaultMessage: 'Mark Complete'
	},
	TC_COMPONENTS_SELF_COMPLETE_BUTTON_MARK_COMPLETE_ARIA_LABEL: {
		id: 'TC_COMPONENTS_SELF_COMPLETE_BUTTON_MARK_COMPLETE_ARIA_LABEL',
		description: 'The aria-label text for self report buttons that still need to be completed.',
		defaultMessage: 'Mark {title} as complete'
	},
	TC_COMPONENTS_SLIDER_DEFAULT_ARIA_LABEL: {
		id: 'TC_COMPONENTS_SLIDER_DEFAULT_ARIA_LABEL',
		description: 'Accessibility label describing the slider component',
		defaultMessage: 'Item Slider'
	},
	TC_COMPONENTS_SLIDER_NEXT_BUTTON_ARIA_LABEL: {
		id: 'TC_COMPONENTS_SLIDER_NEXT_BUTTON_ARIA_LABEL',
		description: 'Accessibility label describing the action of the next button',
		defaultMessage: 'Show next {numPerPage} items'
	},
	TC_COMPONENTS_SLIDER_PREVIOUS_BUTTON_ARIA_LABEL: {
		id: 'TC_COMPONENTS_SLIDER_PREVIOUS_BUTTON_ARIA_LABEL',
		description: 'Accessibility label describing the action of the previous button',
		defaultMessage: 'Show previous {numPerPage} items'
	},
	TC_COMPONENTS_SLIDER_PAGE_ARIA_LABEL: {
		id: 'TC_COMPONENTS_SLIDER_PAGE_ARIA_LABEL',
		description: 'Accessibility label describing the slider page and its position in the slider',
		defaultMessage: 'Page {index} of {total}'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_CTA: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_CTA',
		description: 'Call to action for social share links',
		defaultMessage: 'Share this:'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_SHARE_LABEL: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_SHARE_LABEL',
		description: 'Label of social sharing link',
		defaultMessage: 'Share'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_SHARE_TITLE: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_SHARE_TITLE',
		description: 'Hover title for social share links',
		defaultMessage: 'Share on {type}'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_EMPTY_TITLE: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_EMPTY_TITLE',
		description: 'Hover title for a missing social media field to connect with.',
		defaultMessage: '{type} information not available for {name}'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TITLE: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TITLE',
		description: 'Hover title for connecting via social media.',
		defaultMessage: 'Connect with {name} on {type}'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_VIEW_SELF_PROFILE_TITLE: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_VIEW_SELF_PROFILE_TITLE',
		description: 'Hover title for viewing your own profile social media.',
		defaultMessage: 'View your {type}'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_DIRECT_MESSAGE_TITLE: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_DIRECT_MESSAGE_TITLE',
		description: 'Hover title for connecting via direct message.',
		defaultMessage: 'Send {name} a message'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TYPE_EMAIL: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TYPE_EMAIL',
		description: 'The email option for social media connections.',
		defaultMessage: 'Email'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TYPE_FACEBOOK: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TYPE_FACEBOOK',
		description: 'The facebook option for social media connections.',
		defaultMessage: 'Facebook'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TYPE_LINKEDIN: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TYPE_LINKEDIN',
		description: 'The linkedin option for social media connections.',
		defaultMessage: 'LinkedIn'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TYPE_TWITTER: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TYPE_TWITTER',
		description: 'The twitter option for social media connections.',
		defaultMessage: 'Twitter'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TYPE_DIRECT_MESSAGE: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_CONNECT_TYPE_DIRECT_MESSAGE',
		description: 'The direct message (DM) option for social media connections.',
		defaultMessage: 'Direct Message'
	},
	TC_COMPONENTS_SOCIAL_MEDIA_TWEET_LABEL: {
		id: 'TC_COMPONENTS_SOCIAL_MEDIA_TWEET_LABEL',
		description: 'Label of social sharing tweet link',
		defaultMessage: 'Tweet'
	},
	TC_COMPONENTS_TABLE_ERROR_MESSAGE: {
		id: 'TC_COMPONENTS_TABLE_ERROR_MESSAGE',
		description: 'Message to display if an error occurred loading the data for the table.',
		defaultMessage: 'There was an error loading the data'
	},
	TC_COMPONENTS_TABLE_NO_DATA_MESSAGE: {
		id: 'TC_COMPONENTS_TABLE_NO_DATA_MESSAGE',
		description: 'Message to display when there is no data to show in the table.',
		defaultMessage: 'There is no data to display'
	},
	TC_COMPONENTS_TABLE_PAGINATION_TOOLBAR_PAGE_SIZE_DROPDOWN_LABEL: {
		id: 'TC_COMPONENTS_TABLE_PAGINATION_TOOLBAR_PAGE_SIZE_DROPDOWN_LABEL',
		description: 'Label for page size dropdown button toggle',
		defaultMessage: 'Items Per Page:'
	},
	TC_COMPONENTS_TEXT_EDITOR_TOOLBAR_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_TOOLBAR_TITLE',
		description: 'The title for the WYSIWYG toolbar.',
		defaultMessage: 'Button Toolbar'
	},
	TC_COMPONENTS_TEXT_EDITOR_ALIGN_LEFT_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_ALIGN_LEFT_BUTTON_TITLE',
		description: 'Button title for the align left menu button',
		defaultMessage: 'Left align (Ctrl+Shift+L)'
	},
	TC_COMPONENTS_TEXT_EDITOR_ALIGN_CENTER_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_ALIGN_CENTER_BUTTON_TITLE',
		description: 'Button title for the align center menu button',
		defaultMessage: 'Center align (Ctrl+Shift+E)'
	},
	TC_COMPONENTS_TEXT_EDITOR_ALIGN_RIGHT_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_ALIGN_RIGHT_BUTTON_TITLE',
		description: 'Button title for the align right menu button',
		defaultMessage: 'Right align (Ctrl+Shift+R)'
	},
	TC_COMPONENTS_TEXT_EDITOR_BOLD_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_BOLD_BUTTON_TITLE',
		description: 'Button title for the bold menu button',
		defaultMessage: 'Bold (Ctrl+B)'
	},
	TC_COMPONENTS_TEXT_EDITOR_EMOJI_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_EMOJI_BUTTON_TITLE',
		description: 'Button title for the emoji menu button',
		defaultMessage: 'Insert emoji'
	},
	TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_ONE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_ONE',
		description: 'Label for the level one heading option',
		defaultMessage: 'Heading 1'
	},
	TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_TWO: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_TWO',
		description: 'Label for the level two heading option',
		defaultMessage: 'Heading 2'
	},
	TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_THREE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_THREE',
		description: 'Label for the level three heading option',
		defaultMessage: 'Heading 3'
	},
	TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_NORMAL_TEXT: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_NORMAL_TEXT',
		description: 'Label for the normal text option',
		defaultMessage: 'Normal Text'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_BUTTON_TITLE',
		description: 'Title for the image menu button',
		defaultMessage: 'Insert image'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_CENTER_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_CENTER_BUTTON_TITLE',
		description: 'Title for center image button',
		defaultMessage: 'Center'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_DESCRIPTION_HINT: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_DESCRIPTION_HINT',
		description: 'Helper text to explain the use of the image description',
		defaultMessage: 'This text will be used for accessibility only, it will not appear below the image.'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_DESCRIPTION_PLACEHOLDER: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_DESCRIPTION_PLACEHOLDER',
		description: 'Placeholder text for the image description input',
		defaultMessage: 'Include a description'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_FULL_WIDTH_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_FULL_WIDTH_BUTTON_TITLE',
		description: 'Title for full-width image button',
		defaultMessage: 'Full width'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_INLINE_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_INLINE_BUTTON_TITLE',
		description: 'Button title for the inline menu button',
		defaultMessage: 'Inline'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_LARGE_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_LARGE_BUTTON_TITLE',
		description: 'Title for large image size button',
		defaultMessage: 'Large'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_LEFT_ALIGN_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_LEFT_ALIGN_BUTTON_TITLE',
		description: 'Title for left-align image button',
		defaultMessage: 'Left align'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_LINK_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_LINK_BUTTON_TITLE',
		description: 'Title for link image button',
		defaultMessage: 'Add link'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_MEDIUM_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_MEDIUM_BUTTON_TITLE',
		description: 'Title for medium image size button',
		defaultMessage: 'Medium'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_ORIGINAL_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_ORIGINAL_BUTTON_TITLE',
		description: 'Title for original image size button',
		defaultMessage: 'Original size'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_RIGHT_ALIGN_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_RIGHT_ALIGN_BUTTON_TITLE',
		description: 'Title for right-align image button',
		defaultMessage: 'Right align'
	},
	TC_COMPONENTS_TEXT_EDITOR_IMAGE_SMALL_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_IMAGE_SMALL_BUTTON_TITLE',
		description: 'Title for small image size button',
		defaultMessage: 'Small'
	},
	TC_COMPONENTS_TEXT_EDITOR_ITALIC_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_ITALIC_BUTTON_TITLE',
		description: 'Title for the italic menu button',
		defaultMessage: 'Italic (Ctrl+I)'
	},
	TC_COMPONENTS_TEXT_EDITOR_LINK_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_LINK_BUTTON_TITLE',
		description: 'Title for link menu button',
		defaultMessage: 'Link (Ctrl+K)'
	},
	TC_COMPONENTS_TEXT_EDITOR_LINK_PLACEHOLDER: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_LINK_PLACEHOLDER',
		description: 'Placeholder text for the link input tooltip',
		defaultMessage: 'Enter URL'
	},
	TC_COMPONENTS_TEXT_EDITOR_MERGE_TAG_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_MERGE_TAG_BUTTON_TITLE',
		description: 'Title for merge tag menu button',
		defaultMessage: 'Insert merge tag'
	},
	TC_COMPONENTS_TEXT_EDITOR_MENTION_DROPDOWN_EMPTY_STATE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_MENTION_DROPDOWN_EMPTY_STATE',
		description: 'Message to display when no user matches are found in mention dropdown',
		defaultMessage: 'No match found'
	},
	TC_COMPONENTS_TEXT_EDITOR_ORDERED_LIST_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_ORDERED_LIST_BUTTON_TITLE',
		description: 'Title for the numbered list menu button',
		defaultMessage: 'Numbered list (Ctrl+Shift+7)'
	},
	TC_COMPONENTS_TEXT_EDITOR_UNDERLINE_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_UNDERLINE_BUTTON_TITLE',
		description: 'Title for the underline menu button',
		defaultMessage: 'Underline (Ctrl+U)'
	},
	TC_COMPONENTS_TEXT_EDITOR_UNORDERED_LIST_BUTTON_TITLE: {
		id: 'TC_COMPONENTS_TEXT_EDITOR_UNORDERED_LIST_BUTTON_TITLE',
		description: 'Title for the bulleted list menu button',
		defaultMessage: 'Bulleted list (Ctrl+Shift+8)'
	},
	TC_COMPONENTS_TIME_PICKER_CREATE_OPTION_TEXT: {
		id: 'TC_COMPONENTS_TIME_PICKER_CREATE_OPTION_TEXT',
		description: 'Text for create new option in time picker component',
		defaultMessage: 'Use "{value}"'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_ACTION_TEXT_LOGIN: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_ACTION_TEXT_LOGIN',
		description: 'Text for the user action to "login" into a account',
		defaultMessage: 'Login'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_ACTION_TEXT_REGISTER: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_ACTION_TEXT_REGISTER',
		description: 'Text for the user action to "register" a new account',
		defaultMessage: 'Sign Up'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_BRAND: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_BRAND',
		description: 'The name of the image for the organization\'s brand',
		defaultMessage: '{name} Logo'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_HOME: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_HOME',
		description: 'The name of the icon for the organization\'s home link',
		defaultMessage: '{name} Home'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_EMPTY_MSG: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_EMPTY_MSG',
		description: 'Message Text for the universal navbar when there are no notifications to display',
		defaultMessage: 'You have no notifications'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ERROR_MSG: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ERROR_MSG',
		description: 'Message Text for the universal navbar notifications when there was an API error',
		defaultMessage: 'There was an issue loading the data. Please try again later.'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_BUTTON_LABEL_MARK_ALL_READ: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_BUTTON_LABEL_MARK_ALL_READ',
		description: 'Button label text for the universal navbar notifications dropdown to mark all notifications as read',
		defaultMessage: 'Mark all as read'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_TITLE: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_TITLE',
		description: 'Title text to show on toggle of the notifications dropdown menu',
		defaultMessage: 'Notifications'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_DISCUSSION_COMMENT_CREATED: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_DISCUSSION_COMMENT_CREATED',
		description: 'Notification message to display when a new comment is made in a discussion thread',
		defaultMessage: '<bold>{user_name}</bold> responded to the thread <bold>{parent_object_title}</bold>'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_DISCUSSION_COMMENT_CREATED_ANONYMOUS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_DISCUSSION_COMMENT_CREATED_ANONYMOUS',
		description: 'Notification message to display when a new comment is made in a discussion thread by an anonymous user',
		defaultMessage: 'Someone responded to the thread <bold>{parent_object_title}</bold>'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_DISCUSSION_REPLY_CREATED: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_DISCUSSION_REPLY_CREATED',
		description: 'Notification message to display when a user receives a new reply in a discussion thread',
		defaultMessage: '<bold>{user_name}</bold> replied to you in the thread <bold>{parent_object_title}</bold>'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_DISCUSSION_REPLY_CREATED_ANONYMOUS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_DISCUSSION_REPLY_CREATED_ANONYMOUS',
		description: 'Notification message to display when a user receives a new reply in a discussion thread by an anonymous user',
		defaultMessage: 'Someone replied to you in the thread <bold>{parent_object_title}</bold>'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_EVENT_PERMISSION_GRANTED: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_EVENT_PERMISSION_GRANTED',
		description: 'Notification message to display when a user has been granted permission to attend a restricted event',
		defaultMessage: 'You have been invited to <bold>{title}</bold>'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_EVENT_STARTING: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_EVENT_STARTING',
		description: 'Notification message to display when an event is about to start',
		defaultMessage: '<bold>{title}</bold> is starting soon!'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_USER_MENTIONED: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_USER_MENTIONED',
		description: 'Notification message to display when a user is mentioned in a discussion thread',
		defaultMessage: '<bold>{user_name}</bold> mentioned you in the thread <bold>{parent_object_title}</bold>'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_USER_MENTIONED_ANONYMOUS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATIONS_DROPDOWN_ACTIVITY_DESCRIPTION_USER_MENTIONED_ANONYMOUS',
		description: 'Notification message to display when a user is mentioned in a discussion thread by an anonymous user',
		defaultMessage: 'Someone mentioned you in the thread <bold>{parent_object_title}</bold>'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATION_DROPDOWN_ITEM_LINK_TITLE: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_NOTIFICATION_DROPDOWN_ITEM_LINK_TITLE',
		description: 'Title text for the dropdown item link to the platform activity related to the notification',
		defaultMessage: 'View activity'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_TOGGLE_TITLE_TEXT: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_TOGGLE_TITLE_TEXT',
		description: 'Title text to show on toggle of the user dropdown menu',
		defaultMessage: '{org} Account'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_TO_DASHBOARD: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_TO_DASHBOARD',
		description: 'Dropdown Item Text for link to "dashboard" page for the user',
		defaultMessage: 'Dashboard'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_TO_PROFILE: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_TO_PROFILE',
		description: 'Dropdown Item Text for link to "profile" page for the user',
		defaultMessage: 'Profile'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_TO_SETTINGS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_TO_SETTINGS',
		description: 'Dropdown Item Text for link to "settings" page for the user',
		defaultMessage: 'Settings'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_LANGUAGE_SETTINGS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_LANGUAGE_SETTINGS',
		description: 'Dropdown Item Text for action to open language settings modal',
		defaultMessage: 'Change Language'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_TO_ADMIN_DASHBOARD: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_TO_ADMIN_DASHBOARD',
		description: 'Dropdown Item Text for link to "admin dashboard" page for the organization',
		defaultMessage: 'Admin'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_TO_DOCUMENTATION: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_TO_DOCUMENTATION',
		description: 'Dropdown Item Text for link to "documentation" pages for the TechChange platform',
		defaultMessage: 'Help'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_USER_LOG_OUT: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_USER_LOG_OUT',
		description: 'Dropdown Item Text for action to "log out" the user',
		defaultMessage: 'Log out'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_USER_TIMEZONE: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_USER_TIMEZONE',
		description: 'Title for user timezone display link to user settings',
		defaultMessage: 'Change timezone'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_USER_NO_TIMEZONE: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_USER_NO_TIMEZONE',
		description: 'Title for user timezone display text when no timezone is set',
		defaultMessage: 'No timezone set'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_USER_SESSION_PROGRESS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_USER_SESSION_PROGRESS',
		description: 'Dropdown Item Text for link to "session progress" page for the user',
		defaultMessage: 'Progress'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_USER_SESSION_SETTINGS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_USER_DROPDOWN_ITEM_TEXT_USER_SESSION_SETTINGS',
		description: 'Dropdown Item Text for link to "session settings" page for the user',
		defaultMessage: 'Session Settings'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_DROPDOWN_MENU_POINTS_SUB_HEADER_TEXT: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_DROPDOWN_MENU_POINTS_SUB_HEADER_TEXT',
		description: 'Subheader text for the Points Dropdown Menu',
		defaultMessage: 'You have earned {total} {label}!'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_DROPDOWN_MENU_POINTS_TEXT_POINTS_DEFAULT_LABEL_PLURAL: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_DROPDOWN_MENU_POINTS_TEXT_POINTS_DEFAULT_LABEL_PLURAL',
		description: 'Default plural point label',
		defaultMessage: 'Points'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_DROPDOWN_MENU_POINTS_TEXT_ERROR_MSG_WITH_LABEL: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_DROPDOWN_MENU_POINTS_TEXT_ERROR_MSG_WITH_LABEL',
		description: 'Message Text for the universal navbar points when there was an API error',
		defaultMessage: 'There was an issue loading your {points_label}. Please try again later.'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_DROPDOWN_MENU_POINTS_TEXT_ERROR_MSG_NO_LABEL: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_DROPDOWN_MENU_POINTS_TEXT_ERROR_MSG_NO_LABEL',
		description: 'Message Text for the universal navbar points when there was an API error',
		defaultMessage: 'There was an issue loading the data. Please try again later.'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_ERROR_MSG_SAVE: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_ERROR_MSG_SAVE',
		description: 'Message to display if error occurred in updating the language setting',
		defaultMessage: 'There was an issue saving your preference. Please try again later.'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_AUTO_TRANSLATE_LANGUAGE_LEARN_MORE_BODY: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_AUTO_TRANSLATE_LANGUAGE_LEARN_MORE_BODY',
		description: 'Additional content describing how automated translations on the platform work',
		defaultMessage: 'The TechChange platform uses third-party services, including Google Translate*, to automatically translate user-generated content based on your language preferences. The {icon} icon will indicate whether or not content you are viewing has been machine translated.'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_AUTO_TRANSLATE_LANGUAGE_LEARN_MORE_GOOGLE_TRANSLATE_DISCLAIMER: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_AUTO_TRANSLATE_LANGUAGE_LEARN_MORE_GOOGLE_TRANSLATE_DISCLAIMER',
		description: 'Official disclaimer text for usage of Google Translate API',
		defaultMessage: '* THIS SERVICE MAY CONTAIN TRANSLATIONS POWERED BY GOOGLE. GOOGLE DISCLAIMS ALL WARRANTIES RELATED TO THE TRANSLATIONS, EXPRESS OR IMPLIED, INCLUDING ANY WARRANTIES OF ACCURACY, RELIABILITY, AND ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_AUTO_TRANSLATE_LANGUAGE_LEARN_MORE_TITLE: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_AUTO_TRANSLATE_LANGUAGE_LEARN_MORE_TITLE',
		description: 'Title for additional content describing how automated translations on the platform work',
		defaultMessage: 'Automated Translations'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_AUTO_TRANSLATE_LANGUAGE_LEARN_MORE_TRANSLATION_ICON_ALT_TEXT: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_HEADER_TRANSLATION',
		description: 'Alternative text describing the translation icon',
		defaultMessage: 'translation'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_FORM_FIELD_AUTO_TRANSLATE_DEFAULT_LABEL: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_FORM_FIELD_AUTO_TRANSLATE_DEFAULT_LABEL',
		description: 'Label for the auto-translation default preference field in the language settings modal',
		defaultMessage: 'Automatically translate chat messages and other user-generated content'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_FORM_FIELD_AUTO_TRANSLATE_LANGUAGE_HELP: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_FORM_FIELD_AUTO_TRANSLATE_LANGUAGE_HELP',
		description: 'Help text for the content language select input in the language settings modal',
		defaultMessage: 'Select your preferred language for automated translation of user-generated content (chat messages and more).'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_FORM_FIELD_AUTO_TRANSLATE_LANGUAGE_LABEL: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_FORM_FIELD_AUTO_TRANSLATE_LANGUAGE_LABEL',
		description: 'Label for the content language select input in the language settings modal',
		defaultMessage: 'Automated Translation Language'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_FORM_FIELD_DISPLAY_LANGUAGE_HELP: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_FORM_FIELD_DISPLAY_LANGUAGE_HELP',
		description: 'Help text for the display language select input in the language settings modal',
		defaultMessage: 'Select your preferred language for the platform interface. Note that translations for some features may not be available while updates are still under review.'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_FORM_FIELD_DISPLAY_LANGUAGE_LABEL: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_LANGUAGE_MODAL_FORM_FIELD_DISPLAY_LANGUAGE_LABEL',
		description: 'Label for the display language select input in the language settings modal',
		defaultMessage: 'Display Language'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_PLACEHOLDER_TEXT: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_PLACEHOLDER_TEXT',
		description: 'Placeholder Text for the universal navbar search',
		defaultMessage: 'Search dashboard...'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_LOADING_OPTIONS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_LOADING_OPTIONS',
		description: 'Placeholder Text for the universal navbar search when we are loading options',
		defaultMessage: 'Loading...'
	},
	// TODO: update translations
	TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_NO_MATCH: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_NO_MATCH',
		description: 'Placeholder Text for the universal navbar search when there are no matching options',
		defaultMessage: 'We did not find a match for your search.'
	},
	// TODO: update translations
	TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_VIEW_ENROLLMENTS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_VIEW_ENROLLMENTS',
		description: 'Placeholder Text for the universal navbar search with a link to the enrollments for the user',
		defaultMessage: 'View Dashboard'
	},
	// TODO: update translations
	TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_NO_OPTIONS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_NO_OPTIONS',
		description: 'Placeholder Text for the universal navbar search when there are no options',
		defaultMessage: 'Looks like you haven\'t registered for anything yet.'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_ERROR_HEADER: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_ERROR_HEADER',
		description: 'Header Text for the universal navbar search when there was an API error',
		defaultMessage: 'Search Failed'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_ERROR_MSG: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_TEXT_ERROR_MSG',
		description: 'Message Text for the universal navbar search when there was an API error',
		defaultMessage: 'Please try again, or click {link} to go to your dashboard.'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_RESULTS_OPTION_TEXT_LINK_TO_ADMIN: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_SEARCH_DROPDOWN_MENU_RESULTS_OPTION_TEXT_LINK_TO_ADMIN',
		description: 'Text for the universal navbar search results option related to linking to the Admin pages',
		defaultMessage: 'Admin'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_LINK_TO_HERE: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_LINK_TO_HERE',
		description: 'Text for the universal navbar click on a link "here"',
		defaultMessage: 'here'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_STARTS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_STARTS',
		description: 'Text for the universal navbar to display the upcoming start date for a session',
		defaultMessage: 'Starts {date}'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_STARTED: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_STARTED',
		description: 'Text for the universal navbar to display the past start date for a session',
		defaultMessage: 'Started {date}'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_ENDS: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_ENDS',
		description: 'Text for the universal navbar to display the upcoming end date for a session',
		defaultMessage: 'Ends {date}'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_ENDED: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_ENDED',
		description: 'Text for the universal navbar to display the past end date for a session',
		defaultMessage: 'Ended {date}'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_SAME_DAY: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_SAME_DAY',
		description: 'Text for the universal navbar to display for a same day session',
		defaultMessage: '{date}'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_START_TO_END: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TEXT_SESSION_START_TO_END',
		description: 'Text for the universal navbar to display for a session with a start and end date',
		defaultMessage: '{start} - {end}'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TITLE_TEXT_LINK_TO_COURSE: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TITLE_TEXT_LINK_TO_COURSE',
		description: 'Title text for the universal navbar click on a link to the course',
		defaultMessage: 'Go to {title}'
	},
	TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TITLE_TEXT_LINK_TO_ADMIN: {
		id: 'TC_COMPONENTS_UNIVERSAL_NAVBAR_GENERAL_TITLE_TEXT_LINK_TO_ADMIN',
		description: 'Title text for the universal navbar click on a link to the admin',
		defaultMessage: 'Go to Admin'
	},
	TC_COMPONENTS_USER_AVATAR_SPEAKER_BADGE_LABEL: {
		id: 'TC_COMPONENTS_USER_AVATAR_SPEAKER_BADGE_LABEL',
		description: 'Label text for the speaker badge',
		defaultMessage: 'Speaker'
	},
	TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_ERROR: {
		id: 'TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_ERROR',
		description: 'Generic error message for library video',
		defaultMessage: 'Error loading video. Please try again later.',
	},
	TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_STATUS_NOT_READY_USER: {
		id: 'TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_STATUS_NOT_READY_USER',
		description: 'Alert for library video if user is not an admin and video status is not ready ',
		defaultMessage: 'Content will be available soon!',
	},
	TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_STATUS_NOT_READY_ADMIN: {
		id: 'TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_STATUS_NOT_READY_ADMIN',
		description: 'Alert for library video if user is an admin and video status is not ready ',
		defaultMessage: 'Video not yet ready for playback. The latest video status is "{status}".',
	},
	TC_COMPONENTS_VIDEO_LIBRARY_UPLOADER_GENERATED_SUBTITLES_HELP: {
		id: 'TC_COMPONENTS_VIDEO_LIBRARY_UPLOADER_GENERATED_SUBTITLES_HELP',
		description: 'Help text for the generated subtitles option.',
		defaultMessage: 'Select a language in which to generate automatic subtitles, if desired. Note that this should only be used for videos with a single language and clear audio for best results. This can only be configured on video creation.',
	},
	TC_COMPONENTS_VIDEO_LIBRARY_UPLOADER_GENERATED_SUBTITLES_LABEL: {
		id: 'TC_COMPONENTS_VIDEO_LIBRARY_UPLOADER_GENERATED_SUBTITLES_LABEL',
		description: 'Label for the generated subtitles option.',
		defaultMessage: 'Generated Subtitles',
	},
	TC_COMPONENTS_VIDEO_LIBRARY_UPLOADER_FILE_PICKER_BUTTON_LABEL: {
		id: 'TC_COMPONENTS_VIDEO_LIBRARY_UPLOADER_FILE_PICKER_BUTTON_LABEL',
		description: 'Label for the button to select a video file.',
		defaultMessage: 'Upload video',
	},
	TC_COMPONENTS_COOKIE_CONFIRMATION_HEADER: {
		id: 'TC_COMPONENTS_COOKIE_CONFIRMATION_HEADER',
		description: 'Header for the cookie confirmation module',
		defaultMessage: 'Data Preferences'
	},
	TC_COMPONENTS_COOKIE_CONFIRMATION_POLICIES_TITLE: {
		id: 'TC_COMPONENTS_COOKIE_CONFIRMATION_POLICIES_TITLE',
		description: 'Title text for the GDPR policies link',
		defaultMessage: 'Our GDPR Policies'
	},
	TC_COMPONENTS_COOKIE_CONFIRMATION_DESCRIPTION: {
		id: 'TC_COMPONENTS_COOKIE_CONFIRMATION_DESCRIPTION',
		description: 'Description explaining the cookie confirmation module',
		defaultMessage: 'This website requires cookies to function, but uses optional cookies for:'
	},
	TC_COMPONENTS_COOKIE_CONFIRMATION_ANALYTICS: {
		id: 'TC_COMPONENTS_COOKIE_CONFIRMATION_ANALYTICS',
		description: 'Label for the analytics cookie in the cookie confirmation module',
		defaultMessage: 'Analytics'
	},
	TC_COMPONENTS_COOKIE_CONFIRMATION_DEBUGGING: {
		id: 'TC_COMPONENTS_COOKIE_CONFIRMATION_DEBUGGING',
		description: 'Label for the debugging cookie in the cookie confirmation module',
		defaultMessage: 'Debugging'
	},
	TC_COMPONENTS_COOKIE_CONFIRMATION_ACCEPT: {
		id: 'TC_COMPONENTS_COOKIE_CONFIRMATION_ACCEPT',
		description: 'Accept button text for the cookie confirmation module',
		defaultMessage: 'Accept'
	},
	TC_COMPONENTS_COOKIE_CONFIRMATION_REJECT: {
		id: 'TC_COMPONENTS_COOKIE_CONFIRMATION_REJECT',
		description: 'Reject button text for the cookie confirmation module',
		defaultMessage: 'Reject'
	},
	TC_COMPONENTS_WITH_RESOURCE_LOGIC_ERROR_MSG_MISSING_DEFAULT_TRANSLATION: {
		id: 'TC_COMPONENTS_WITH_RESOURCE_LOGIC_ERROR_MSG_MISSING_DEFAULT_TRANSLATION',
		description: 'Error message text when translation in default language is missing.',
		defaultMessage: 'Translation is missing for the default language'
	},
	TC_COMPONENTS_WITH_RESOURCE_LOGIC_ERROR_MSG_LOAD_RESOURCE: {
		id: 'TC_COMPONENTS_WITH_RESOURCE_LOGIC_ERROR_MSG_LOAD_RESOURCE',
		description: 'Error message text when resource load fails for translation.',
		defaultMessage: 'Failed to load translation'
	},
	TC_COMPONENTS_WITH_RESOURCE_LOGIC_WARNING_MSG_DELETE_RESOURCE: {
		id: 'TC_COMPONENTS_WITH_RESOURCE_LOGIC_WARNING_MSG_DELETE_RESOURCE',
		description: 'Warning message text for deleting a resource.',
		defaultMessage: 'This action will delete all the content and completion tracking rules related to <bold>{title}</bold>.'
	},
	TC_COMPONENTS_MIRO_BOARD_SELECTOR_TITLE: {
		id: 'TC_COMPONENTS_MIRO_BOARD_SELECTOR_TITLE',
		description: 'Title text for Miro board selector component.',
		defaultMessage: 'Choose a Board'
	},
	TC_COMPONENTS_MIRO_BOARD_SELECTOR_NEW_BOARD: {
		id: 'TC_COMPONENTS_MIRO_BOARD_SELECTOR_NEW_BOARD',
		description: 'Card text for creating a new Miro board.',
		defaultMessage: 'New Board'
	},
	TC_COMPONENTS_MIRO_BOARD_SELECTOR_CLOSE_BTN_LABEL: {
		id: 'TC_COMPONENTS_MIRO_BOARD_SELECTOR_CLOSE_BTN_LABEL',
		description: 'Button label text for closing the Miro board selector.',
		defaultMessage: 'Close the Miro board selector'
	},
	TC_COMPONENTS_MIRO_BOARD_SELECTOR_GET_BOARDS_ERROR: {
		id: 'TC_COMPONENTS_MIRO_BOARD_SELECTOR_GET_BOARDS_ERROR',
		description: 'Error alert text when failed to get Miro boards.',
		defaultMessage: 'Something went wrong. Cannot get boards.'
	},
	TC_COMPONENTS_MIRO_BOARD_SELECTOR_NEW_BOARD_ERROR: {
		id: 'TC_COMPONENTS_MIRO_BOARD_SELECTOR_NEW_BOARD_ERROR',
		description: 'Error alert text when failed to create a new Miro board.',
		defaultMessage: 'Something went wrong. Cannot create new board.'
	},
	TC_COMPONENTS_MIRO_BOARD_SELECTOR_SEARCH_BAR_PLACEHOLDER_TEXT: {
		id: 'TC_COMPONENTS_MIRO_BOARD_SELECTOR_SEARCH_BAR_PLACEHOLDER_TEXT',
		description: 'Placeholder text for search bar.',
		defaultMessage: 'Search boards...'
	},
	TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_TITLE_TEXT: {
		id: 'TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_TITLE_TEXT',
		description: 'The title text to prompt the user to authorize their connection with the TechChange supported 3rd-party API integrations',
		defaultMessage: 'Manage Your Integrations'
	},
	TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_ERROR_TEXT: {
		id: 'TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_ERROR_TEXT',
		description: 'The error text when prompting the user to authorize their connection with the TechChange supported 3rd-party API integrations',
		defaultMessage: 'Error loading your integrations data, please try again later.'
	},
	TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_DISABLED_TEXT: {
		id: 'TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_DISABLED_TEXT',
		description: 'The text to show when the 3rd-party API is disabled for the organization.',
		defaultMessage: 'The required integration is not available.'
	},
	TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_FAILURE_TEXT: {
		id: 'TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_FAILURE_TEXT',
		description: 'The failure text when the user is unable to authorize their connection with the TechChange supported 3rd-party API integrations',
		defaultMessage: 'Error connecting with {name}, please try again later.'
	},
	TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_MIRO_SHORT_DESCRIPTION: {
		id: 'TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_MIRO_SHORT_DESCRIPTION',
		description: 'Short description of the Miro integration option',
		defaultMessage: 'Easily collaborate using a visual whiteboard and sticky notes.'
	},
	TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_ZOOM_SHORT_DESCRIPTION: {
		id: 'TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_ZOOM_SHORT_DESCRIPTION',
		description: 'Short description of the Zoom integration option',
		defaultMessage: 'Schedule events, connect with team members, and attend virtual meetings.'
	},
	TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_CONNECT_BUTTON_TEXT: {
		id: 'TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_CONNECT_BUTTON_TEXT',
		description: 'The button label to prompt the user to authorize their connection with the TechChange supported 3rd-party API integrations',
		defaultMessage: 'Connect'
	},
	TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_CONNECT_BUTTON_ARIA_LABEL: {
		id: 'TC_COMPONENTS_API_INTEGRATION_REQUIRED_AUTHORIZE_MODAL_CONNECT_BUTTON_ARIA_LABEL',
		description: 'The button aria-label to prompt the user to authorize their connection with the TechChange supported 3rd-party API integrations',
		defaultMessage: 'Connect with {name}'
	},
	TC_COMPONENTS_ERROR_PAGE_HEADER: {
		id: 'TC_COMPONENTS_ERROR_PAGE_HEADER',
		description: 'Default header text to show when the page could not be loaded due to an invalid link or other error',
		defaultMessage: 'This page is not available',
	},
	TC_COMPONENTS_ERROR_PAGE_SUBHEADER: {
		id: 'TC_COMPONENTS_ERROR_PAGE_SUBHEADER',
		description: 'Default secondary text to show when the page could not be loaded due to an invalid link or other error',
		defaultMessage: 'The link you followed may be broken, or the page may have been removed.',
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_1_LABEL: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_1_LABEL',
		description: 'The label text for "Step #1" of the content upload process to Lokalise for translation',
		defaultMessage: 'Step 1:'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_1_TEXT_SAVING: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_1_TEXT_SAVING',
		description: 'The saving indicator text for "Step #1" of the content upload process to Lokalise for translation',
		defaultMessage: 'Updating the project settings in Lokalise...'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_1_TEXT_SUCCESS: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_1_TEXT_SUCCESS',
		description: 'The success indicator text for "Step #1" of the content upload process to Lokalise for translation',
		defaultMessage: 'The project settings have been successfully updated in Lokalise!'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_1_TEXT_ERROR: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_1_TEXT_ERROR',
		description: 'The error indicator text for "Step #1" of the content upload process to Lokalise for translation',
		defaultMessage: 'Error updating the project settings in Lokalise!'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_2_LABEL: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_2_LABEL',
		description: 'The label text for "Step #2" of the content upload process to Lokalise for translation',
		defaultMessage: 'Step 2:'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_2_TEXT_SAVING: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_2_TEXT_SAVING',
		description: 'The saving indicator text for "Step #2" of the content upload process to Lokalise for translation',
		defaultMessage: 'Uploading the content to Lokalise... ({progress}%)'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_2_TEXT_SUCCESS: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_2_TEXT_SUCCESS',
		description: 'The success indicator text for "Step #2" of the content upload process to Lokalise for translation',
		defaultMessage: 'The content has been successfully uploaded to <link>Lokalise</link>!'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_2_TEXT_ERROR: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_API_STATUS_STEP_2_TEXT_ERROR',
		description: 'The error indicator text for "Step #2" of the content upload process to Lokalise for translation',
		defaultMessage: 'Error uploading the content to Lokalise!'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_LABEL_TEXT_BASE_SOURCE: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_LABEL_TEXT_BASE_SOURCE',
		description: 'The field label text for "Base Source" in the content upload form to Lokalise for translation',
		defaultMessage: 'Base Source'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_PLACEHOLDER_TEXT_BASE_SOURCE: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_PLACEHOLDER_TEXT_BASE_SOURCE',
		description: 'The field placeholder text for "Base Source" in the content upload form to Lokalise for translation',
		defaultMessage: 'Choose the source content for translation'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_LABEL_TEXT_BASE_LANGUAGE: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_LABEL_TEXT_BASE_LANGUAGE',
		description: 'The field label text for "Base Language" in the content upload form to Lokalise for translation',
		defaultMessage: 'Base Language'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_PLACEHOLDER_TEXT_BASE_LANGUAGE: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_PLACEHOLDER_TEXT_BASE_LANGUAGE',
		description: 'The field placeholder text for "Base Language" in the content upload form to Lokalise for translation',
		defaultMessage: 'Choose the base language'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_LABEL_TEXT_TARGET_LANGUAGES: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_LABEL_TEXT_TARGET_LANGUAGES',
		description: 'The field label text for "Target Languages" in the content upload form to Lokalise for translation',
		defaultMessage: 'Target Languages'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_PLACEHOLDER_TEXT_TARGET_LANGUAGES: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_PLACEHOLDER_TEXT_TARGET_LANGUAGES',
		description: 'The field placeholder text for "Target Languages" in the content upload form to Lokalise for translation',
		defaultMessage: 'Choose the target languages for translation'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_LABEL_TEXT_INCLUDE_EXISTING_TRANSLATIONS: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_LABEL_TEXT_INCLUDE_EXISTING_TRANSLATIONS',
		description: 'The field label text for "Include Existing Translations" in the content upload form to Lokalise for translation',
		defaultMessage: 'Include previous translations'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_HELPER_TEXT_INCLUDE_EXISTING_TRANSLATIONS: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_HELPER_TEXT_INCLUDE_EXISTING_TRANSLATIONS',
		description: 'The field helper text for "Include Existing Translations" in the content upload form to Lokalise for translation',
		defaultMessage: 'If you previously translated this content on the TechChange platform, enable this setting to also send the pre-existing data in the target languages ({languages}) to Lokalise.'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_ARIA_LABEL_TEXT_INCLUDE_EXISTING_TRANSLATIONS: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_ARIA_LABEL_TEXT_INCLUDE_EXISTING_TRANSLATIONS',
		description: 'The field aria-label text for "Include Existing Translations" in the content upload form to Lokalise for translation',
		defaultMessage: 'Learn more about the "Include previous translations" setting.'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_LABEL_TEXT_REPLACE_MODIFIED: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_LABEL_TEXT_REPLACE_MODIFIED',
		description: 'The field label text for "Replace Modified" in the content upload form to Lokalise for translation',
		defaultMessage: 'Replace modified content'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_HELPER_TEXT_REPLACE_MODIFIED: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_HELPER_TEXT_REPLACE_MODIFIED',
		description: 'The field helper text for "Replace Modified" in the content upload form to Lokalise for translation',
		defaultMessage: 'If you\'re re-sending content that is already present in Lokalise, enable this setting to replace it with the most recent data.'
	},
	TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_ARIA_LABEL_TEXT_REPLACE_MODIFIED: {
		id: 'TC_COMPONENTS_TRANSLATIONS_LOKALISE_UPLOAD_FORM_FIELD_ARIA_LABEL_TEXT_REPLACE_MODIFIED',
		description: 'The field aria-label text for "Replace Modified" in the content upload form to Lokalise for translation',
		defaultMessage: 'Learn more about the "Replace modified content" setting.'
	},
});
